// 中文语言包
export default {
  common: {
    back: '返回',
    ignore: '忽略',
    critical: '严重',
    tips: '提示',
    close: '关闭',
    comingSoon: '功能开发中',
    remark: '备注',
    edit: '编辑',
    view: '查看',
    create: '创建',
    save: '保存',
    delete: '删除',
    confirmDelete: '确定要删除吗？',
    confirm: '确认',
    cancel: '取消',
    reset: '重置',
    submit: '提交',
    active: '启用',
    inactive: '停用',
    inUse: '使用中',
    cancelled: '已注销',
    frozen: '已冻结',
    freeze: '冻结',
    unfreeze: '解冻',
    cancelAccount: '注销',
    confirmCancelAccount: '确定要注销该用户吗？注销后用户将无法登录系统。',
    confirmFreeze: '确定要冻结该用户吗？冻结后用户将无法登录系统。',
    confirmUnfreeze: '确定要解冻该用户吗？解冻后用户可以正常登录系统。',
    confirmBatchFreeze: '确定要批量冻结选中的用户吗？',
    confirmBatchUnfreeze: '确定要批量解冻选中的用户吗？',
    confirmBatchCancelAccount: '确定要批量注销选中的用户吗？',
    freezeSuccess: '冻结成功',
    unfreezeSuccess: '解冻成功',
    cancelAccountSuccess: '注销成功',
    batchFreezeSuccess: '批量冻结成功',
    batchUnfreezeSuccess: '批量解冻成功',
    batchCancelAccountSuccess: '批量注销成功',
    enabled: '已开启',
    disabled: '已关闭',
    status: '状态',
    statusPlaceholder: '请选择状态',
    before: '变动前',
    after: '变动后',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    add: '添加',
    addRoot: '新增根权限',
    refresh: '刷新',
    query: '查询',
    search: '搜索',
    loading: '加载中',
    placeholder: '请选择',
    selectPlaceholder: '请选择',
    view: '查看',
    viewMore: '查看更多',
    chatHistory: '聊天记录',
    confirm: '确定',
    cancel: '取消',
    warning: '警告',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    change: '更换',
    loadFailed: '加载失败',
    fetchFailed: '获取数据失败',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    export: '导出',
    exportLogs: '导出日志',
    noData: '暂无数据',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    deleteConfirm: '确定要删除吗？',
    unbind: '解绑',
    unbindSuccess: '解绑成功',
    unbindFailed: '解绑失败',
    bindSuccess: '绑定成功',
    bindFailed: '绑定失败',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    batchDelete: '批量删除',
    batchDeleteSuccess: '批量删除成功',
    batchDeleteFailed: '批量删除失败',
    batchDeleteConfirm: '确定要删除选中的 {count} 个项目吗？',
    batchOperation: '批量操作',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    getDataFailed: '获取数据失败',
    canceled: '已取消',
    unknownError: '未知错误',
    formValidateFailed: '表单验证失败，请检查输入',
    id: 'ID',
    name: '名称',
    description: '描述',
    descriptionPlaceholder: '请输入描述',
    createTime: '创建时间',
    updateTime: '更新时间',
    remarkLength: '备注长度不能超过200个字符',
    all: '全部',
    online: '在线',
    offline: '离线',
    abnormal: '异常',
    operation: '操作',
    operations: '操作',
    actions: '操作',
    action: '操作',
    detail: '详情',
    user: '用户',
    username: '用户名',
    userId: '用户ID',
    deviceCount: '设备数量',
    ip: 'IP地址',
    running: '运行中',
    stopped: '停止',
    remove: '移除',
    date: '日期',
    time: '时间',
    prompt: '提示',
    to: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    success: '成功',
    fail: '失败',
    process: '处理',
    more: '更多',
    today: '今日',
    week: '本周',
    month: '本月',
    quarter: '本季度',
    year: '本年度',
    custom: '自定义',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    last3Months: '最近三个月',
    proportion: '占比',
    dateRange: '日期范围',
    rank: '排名',
    processSuccess: '处理成功',
    processFailed: '处理失败',
    clearSuccess: '清除成功',
    clearFailed: '清除失败',
    clear: '清空',
    copy: '复制',
    copySuccess: '复制成功',
    copyFailed: '复制失败',
    expandLevel1: '仅展开一级',
    checkAll: '全选',
    checkNone: '全不选',
    invertCheck: '反选',
    pleaseInput: '请输入',
    sort: '排序',
    yes: '是',
    no: '否',
    unknown: '未知',
    warning: '警告',
    enterPlaceholder: '请输入',
    selectPlaceholder: '请选择',
    pause: '暂停',
    resume: '继续',
    retry: '重试',
    completed: '完成',
    type: '类型',
    content: '内容',
    logs: '日志'
  },
  modelConfig: {
    searchPlaceholder: '请输入模型名称查询',
    search: '搜索',
    vad: '语言活动检测',
    asr: '语音识别',
    llm: '大语言模型',
    vllm: '视觉大语言模型',
    intent: '意图识别',
    tts: '语音合成',
    memory: '记忆模块',
    rag: '知识库',
    imggen: '图像生成',
    plugin: '插件工具',
    modelId: '模型ID',
    modelName: '模型名称',
    provider: '提供商',
    unknown: '未知',
    isEnabled: '是否启用',
    isDefault: '是否默认',
    action: '操作',
    voiceManagement: '音色管理',
    edit: '编辑',
    duplicate: '创建副本',
    delete: '删除',
    batchDelete: '批量删除',
    deselectAll: '取消全选',
    select: '选择',
    selectAll: '全选',
    add: '添加模型',
    selectModelsFirst: '请先选择要删除的模型',
    confirmBatchDelete: '确定要删除选中的模型吗?',
    confirmDelete: '确定要删除该模型吗?',
    batchDeleteSuccess: '批量删除成功',
    partialDeleteFailed: '部分删除失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    deleteCancelled: '删除已取消',
    duplicateSuccess: '创建副本成功',
    duplicateFailed: '创建副本失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    addSuccess: '添加成功',
    addFailed: '添加失败',
    fetchModelsFailed: '获取模型列表失败',
    enableSuccess: '启用成功',
    disableSuccess: '禁用成功',
    operationFailed: '操作失败',
    setDefaultSuccess: '设置默认模型成功',
    activationStatus: '开通状态',
    activated: '已开通',
    unactivated: '未开通',
    activationDate: '开通时间',
    expirationDate: '到期时间',
    batchOperation: '批量操作',
    batchActivate: '批量开通',
    batchDeactivate: '批量关闭开通',
    batchActivateSuccess: '批量开通成功',
    batchDeactivateSuccess: '批量关闭成功',
    itemsPerPage: '{items}条/页',
    firstPage: '首页',
    prevPage: '上一页',
    nextPage: '下一页',
    totalRecords: '共{total}条记录',
    loading: '拼命加载中',
    viewQuota: '查看额度',
    quotaInfo: '账户额度信息',
    totalQuota: '总额度',
    usedQuota: '已用额度',
    remainingQuota: '剩余额度',
    refreshQuota: '刷新额度',
    checkKeyFirst: '请先配置并保存API Key后再查看',
    enabled: '已启用',
    disabled: '已禁用',
    default: '默认',
    nonDefault: '非默认',
    dynamicParams: '动态参数配置',
    noDynamicParams: '暂无动态参数',
    refresh: '刷新',
    fetchDetailFailed: '加载模型详情失败',
    usageProgress: '使用进度',
    noQuotaConfigured: '未配置总额度，请先在编辑页面设置模型总额度。'
  },
  modelConfigDialog: {
    addModel: '添加模型',
    editModel: '编辑模型',
    viewDetail: '模型详情',
    duplicateModel: '创建副本',
    copySuffix: '_副本',
    modelInfo: '模型信息',
    modelType: '模型类型',
    status: '状态',
    enable: '是否启用',
    setDefault: '设为默认',
    modelId: '模型ID',
    enterModelId: '未填写将自动生成模型ID',
    modelName: '模型名称',
    enterModelName: '请输入模型名称',
    modelCode: '模型编码',
    enterModelCode: '请输入模型编码',
    supplier: '供应器',
    selectSupplier: '请选择',
    sortOrder: '排序号',
    enterSortOrder: '请输入排序号',
    docLink: '文档地址',
    enterDocLink: '请输入文档地址',
    totalQuota: '总额度 Token',
    enterTotalQuota: '请输入模型总额度 (0表示无限)',
    threshold: '告警阈值 (%)',
    enterThreshold: '请输入告警阈值 (0-100)',
    usedQuota: '已用额度',
    remainingQuota: '剩余额度',
    remark: '备注',
    enterRemark: '请输入模型备注',
    callInfo: '调用信息',
    enterJsonExample: '请输入JSON格式变量(示例:{"key":"value"})',
    save: '保存'
  },
  dashboard: {
    title: '控制中心',
    userCount: '用户总数',
    deviceCount: '设备总数',
    resourceUsage: '资源使用率',
    pendingAlerts: '待处理告警',
    resourceTrend: '资源使用趋势',
    deviceStatus: '设备状态分布',
    deviceVersion: '设备版本',
    recentActivities: '最近活动',
    systemStatus: '系统状态',
    quickActions: '快捷操作',
    createUser: '添加用户',
    createAgent: '创建智能体',
    chatHistory: '聊天记录',
    agentCount: '智能体总数',
    digitalCollectionCount: '数字藏品总数',
    badgeCount: '徽章发放总数',
    badgeGrowth: '徽章发放增长',
    bindDevice: '绑定设备',
    anomaly: '异常',
    growthTrend: '增长趋势',
    userGrowth: '用户增长',
    deviceGrowth: '设备增长',
    agentGrowth: '智能体增长',
    digitalCollectionGrowth: '数字藏品增长',
    quotaManagement: '配额管理',
    customize: '自定义',
    customizeQuickActions: '自定义快捷操作',
    selectQuickActions: '选择显示在首页的快捷操作',
    maxQuickActions: '最多选择 8 个快捷操作',
    userList: '用户列表',
    deviceList: '设备列表',
    systemLogs: '系统日志',
    notificationManagement: '通知管理',
    alarmManagement: '告警管理',
    serverMonitor: '服务器监控',
    systemConfig: '系统配置',
    days: '天',
    viewMore: '查看更多',
    detailedMonitoring: '详细监控',
    trendUp: '+12%',
    trendUpLow: '+8%',
    trendDown: '-5%',
    trendUpAlert: '+3',
    increase: '+',
    decrease: '-',
    days7: '7天',
    days30: '30天',
    days90: '90天',
    apiCalls: 'AI接口调用',
    storageUsage: '存储使用(MB)',
    offline: '离线',
    maintenance: '维护中',
    error: '异常',
    apiService: 'API服务',
    database: '数据库',
    messageQueue: '消息队列',
    fileStorage: '文件存储',
    hours: '小时',
    minutes: '分钟',
    justNow: '刚刚',
    userCreatedAccount: '用户 {username} 创建了新账户',
    deviceOnline: '设备 {mac} 上线',
    userQuotaAdjusted: '用户 {username} 资源配额调整',
    systemBackupCompleted: '系统完成定期备份',
    daysAgo: '{days}天前',
    hoursAgo: '{hours}小时前',
    minutesAgo: '{minutes}分钟前',
    weekday1: '周一',
    weekday2: '周二',
    weekday3: '周三',
    weekday4: '周四',
    weekday5: '周五',
    weekday6: '周六',
    weekday7: '周日',
    deviceOnlineMsg: '设备 {mac} 上线',
    userQuotaAdjustedMsg: '用户{username}资源配额调整',
    systemBackupCompletedMsg: '系统完成定期备份'
  },
  layout: {
    systemTitle: '智能体管理系统',
    home: '控制中心',
    userManagement: '用户管理',
    agentManagement: '智能体管理',
    deviceManagement: '设备管理',
    resourceManagement: '资源管理',
    activityManagement: '活动管理',
    communityActivity: '社区活动',
    activityMemorial: '活动纪念',
    rightsShop: '权益商店',
    rightsExchange: '兑换记录',
    systemManagement: '系统管理',
    userList: '用户列表',
    userGroup: '用户分组',
    rolePermissions: '角色权限',
    permissionManagement: '权限管理',
    deviceList: '设备列表',
    deviceBind: '设备绑定',
    firmwareUpgrade: '固件升级',
    deviceLogs: '设备日志',
    resourceOverview: '资源监控',
    quotaManagement: '配额管理',
    usageReport: '使用报表',
    modelManagement: '模型管理',
    quotaDetail: '配额详情',
    quotaPolicy: '配额策略',
    usageDetails: '使用明细',
    usageAmount: '使用量',
    businessType: '业务类型',
    usageTrend: '使用趋势',
    operationLog: '日志管理',
    notificationManagement: '通知管理',
    alarmManagement: '告警管理',
    serverMonitor: '服务器监控',
    jobManagement: '定时任务',
    jobLog: '任务日志',
    systemConfig: '系统配置',
    profile: '个人资料',
    settings: '系统设置',
    logout: '退出登录',
    expandMenu: '展开菜单',
    collapseMenu: '收起菜单',
    admin: '管理员',
    logoutSuccess: '退出成功',
    logoutError: '退出失败'
  },
  analysis: {
    dataAnalysis: '数据分析',
    overview: '数据总览',
    overviewDesc: '全局核心指标汇总，快速查看整体业务规模与活动阶段性差异',
    userAnalysis: '用户数据分析',
    userAnalysisDesc: '分析拉新规模、新增趋势、完整用户转化链路，定位流失节点',
    productAnalysis: '产品数据分析',
    productAnalysisDesc: '产品访问量、转化率等指标分析',
    collectionAnalysis: '数字藏品分析',
    collectionAnalysisDesc: '周边藏品热度、多系列收集完成度横向对比',
    badgeAnalysis: '徽章活动分析',
    badgeAnalysisDesc: '线下活动徽章数据复盘，补齐转化漏斗、活动分段对比分析',
    userActivity: '日活用户分析',
    userActivityDesc: '用户活跃度与渠道贡献分析，定位活跃增长点与渠道分布',
    comingSoon: '开发中',
    placeholderTip: '该模块正在开发中，敬请期待',
    overviewPlan: '将包含：五大业务板块 KPI 卡片、活动三阶段对比柱状图、四大业务迷你缩略趋势图',
    userAnalysisPlan: '将包含：用户增长趋势图、用户行为组合占比、用户分层占比环形图',
    productVisitConversion: '产品访问与转化',
    productAnalysisPlan: '将包含：产品访问量趋势、转化率漏斗、产品热度排行',
    collectionTrendRanking: '藏品趋势与排行',
    collectionAnalysisPlan: '将包含：每日收藏趋势、产品热度排行、双系列点亮分析、完成率对比',
    badgeIssuanceFunnel: '徽章发放与漏斗',
    badgeAnalysisPlan: '将包含：徽章发放趋势、三类徽章对比、集齐转化漏斗',
    coreMetrics: '核心指标',
    dimension: '维度',
    timeRange: '时间范围',
    today: '今日',
    week: '近7天',
    month: '近30天',
    quarter: '近90天',
    year: '近1年',
    custom: '自定义',
    granularity: '粒度',
    granularityAuto: '自动',
    granularityHour: '小时',
    granularityDay: '天',
    granularityWeek: '周',
    granularityMonth: '月',
    rangeSeparator: '至',
    startDate: '开始日期',
    endDate: '结束日期',
    refresh: '刷新',
    anomaly: '异常',
    anomalyTip: '数据出现异常波动',
    yesterday: '前一日',
    back: '返回',
    noRetentionData: '暂无留存数据',
    retentionRate: '留存率',
    noFunnelData: '暂无漏斗数据',
    funnelValue: '用户数',
    funnelOverallRate: '总转化率',
    funnelDropOff: '流失数',
    funnel: '漏斗',
    loading: '加载中...',
    noData: '暂无数据',
    coreMetricsCard: '核心指标卡',
    miniTrend: '迷你趋势',
    growthDualAxis: '增长趋势',
    conversionFunnel: '转化漏斗',
    userSegmentationChart: '用户分层占比',
    retentionMatrix: '留存矩阵',
    dailyTrend: '每日趋势',
    issuanceTrend: '发放趋势',
    badgeFunnel: '集齐漏斗',
    visitTrend: '使用趋势',
    productRanking: '产品热度排行',
    deviceActivity: '设备活跃度分析',
    deviceActivityDesc: '按设备末次使用距今天数统计的活跃状态分布, 全量口径不受时间范围影响',
    firmwareDist: '固件版本分布',
    deviceRenameStatus: '设备改名状态',
    userDeviceDist: '用户持有设备数分布',
    collectionRanking: '藏品排行',
    collectionRankingDesc: '时间范围内获取数量最多的藏品Top10, 与每日趋势时间范围联动',
    seriesRanking: '系列排行',
    seriesRankingDesc: '全量统计各系列藏品获取量Top10, 不受时间筛选影响; 点击柱体可下钻查看系列详情',
    nfcUserRanking: 'NFC用户排行',
    nfcProductRanking: 'NFC绑定排行',
    nfcSwipeRanking: 'NFC刷卡排行',
    nfcUserDaysRanking: 'NFC使用天数排行',
    badgeRanking: '徽章排行',
    rank: '排名',
    rankName: '名称',
    rankValue: '数值',
    rankUnit: '单位',
    rankProportion: '占比',
    topN: 'TopN',
    overallConversion: '整体转化',
    totalUsers: '总用户',
    totalDevices: '累计设备',
    totalNfc: '累计刷卡',
    totalCollections: '累计藏品',
    totalBadges: '累计徽章',
    dimUser: '用户',
    dimDevice: '设备',
    dimAgent: '智能体',
    dimCollection: '数字藏品',
    dimNfc: 'NFC刷卡',
    dimBadge: '徽章',
    allBadgeTypes: '全部类型',
    badgeIssuance: '徽章发放',
    trendCompare: '趋势对比',
    chartType: '图表类型',
    lineChart: '折线图',
    barChart: '柱状图',
    metricUser: '新增用户',
    metricDevice: '新增设备',
    metricNfc: 'NFC刷卡',
    metricCollection: '藏品获取',
    metricBadge: '徽章发放',
    metricDau: '活跃DAU',
    funnelType: '漏斗类型',
    funnelUserAcquisition: '用户获取链路',
    funnelBadgeCollection: '徽章集齐链路',
    segmentNewInactive: '新注册未活跃',
    segmentActiveNoInteract: '活跃无互动',
    segmentShallow: '浅活跃',
    segmentDeep: '深度活跃',
    segmentChurned: '流失用户',
    cohortDate: '批次日期',
    cohortSize: '批次人数',
    dayOffset: '第N日',
    retainedUsers: '留存人数',
    peakDau: '峰值DAU',
    avgDau: '周期平均DAU',
    wau: '周活跃用户(WAU)',
    activityOverview: '整体活跃用户分析',
    channelContribution: '渠道贡献占比',
    channelContributionTip: 'NFC/数字藏品/徽章 三渠道对活跃用户的贡献比例',
    nextDayRetention: '次日留存率',
    avgActivityLevel: '平均活跃度',
    activePenetration: '活跃渗透率',
    nextDayRetentionDesc: '区间内相邻两日均活跃用户占比均值',
    avgActivityLevelDesc: '区间内人均每日动作次数',
    activePenetrationDesc: '区间去重活跃用户占总用户比',
    dauTrendTitle: 'DAU趋势 (NFC / 收藏 / 徽章 合计)',
    dauTrendTip: '时间范围内每日去重活跃用户曲线',
    peakLabel: '峰值',
    dauChannelStack: 'DAU渠道堆叠',
    dauChannelStackTip: 'NFC/数字藏品/徽章 每日活跃用户分层叠加',
    channelNfc: 'NFC刷卡',
    channelCollection: '数字藏品',
    channelBadge: '徽章',
    dauUnit: '人',
    activityAssessment: '留存与活跃综合评估',
    seriesAnalysisTitle: '系列分析',
    seriesUsers: '系列用户',
    fullSetWithoutHidden: '全套点亮(不含隐藏)',
    hiddenOwners: '隐藏款持有',
    fullSetWithHidden: '全套含隐藏',
    seriesAnalysisPercentOfUsers: '占系列用户 {p}',
    itemCollectorsTitle: '单品收藏人数',
    itemCollectorsTip: '每个藏品的去重持有用户数,隐藏款以橙色标识',
    holdingDistributionTitle: '用户持有数量分层',
    holdingDistributionTip: '按用户持有的该系列藏品数量区间统计',
    collectors: '收藏人数',
    userCount: '用户数',
    hiddenTag: '隐藏款',
    // ---- 数据总览 ----
    dimChat: 'AI对话',
    todayNewUsers: '今日新增用户',
    todayNfcSwipes: '今日刷卡',
    todayChats: '今日对话',
    todayCollections: '今日藏品',
    todayBadges: '今日徽章',
    // ---- 日活用户分析 ----
    mau: '月活跃用户(MAU)',
    stickiness: '活跃粘性(DAU/MAU)',
    newOldComposition: '新老用户构成',
    newOldCompositionTip: '按注册时长分层的每日活跃用户构成',
    segNewUser: '当日新用户',
    segD1To30: '注册1-30天',
    segD31To90: '注册31-90天',
    segD90Plus: '注册90天以上',
    weekReturnRate: '7日回访率',
    weekReturnRateDesc: '区间内活跃用户在随后7天内再次活跃的占比均值',
    timesUnit: '次',
    dauKpiDesc: '峰值/平均DAU统计范围与趋势图一致; WAU/MAU为滚动近7/30天去重活跃用户; 粘性=平均DAU/MAU×100%',
    dauTrendDesc: '每日去重活跃用户数(DAU)曲线, 红点标注区间峰值; 活跃口径=当日有NFC刷卡/获得藏品/获得徽章任一行为的去重用户',
    activityOverviewDesc: '三渠道去重活跃占比(同一用户多渠道会重复计入)与留存活跃评估; 次日留存/7日回访为区间均值, 活跃渗透率=区间活跃用户/总注册用户',
    activityAssessmentTip: '基于完整自然日快照的留存与回访综合评估',
    newOldDesc: '每日DAU按注册时长分为当日新注册/1-30天/31-90天/90天以上四层堆叠, 观察新老用户活跃结构演变',
    channelStackDesc: '每日DAU按NFC刷卡/数字藏品/徽章三渠道分层堆叠(多渠道用户重复计入), 识别活跃增长的主要渠道',
    retentionAvgLabel: '平均留存率(已到期cohort)',
    retentionMatrixDesc: '每行为一个注册日期群cohort(括号内为当日注册数), 列为注册后第N日(D+N)仍活跃的用户占比; 留存率=D+N日活跃人数/注册人数, "-"表示该日尚未到达; 数据为每日00:15生成的完整自然日快照',
    snapshotNote: '本模块基于完整自然日快照统计(每日00:10/00:15生成), 不含当天实时数据, 当天数据于次日凌晨生成后展示',
    // ---- 用户数据分析 ----
    levelDistribution: '用户等级分布',
    pointsDistribution: '积分余额分布',
    registerTrend: '近12月注册趋势',
    // ---- 用户行为组合占比 ----
    behaviorCombo: '用户行为组合占比',
    behaviorComboTip: '全量统计设备绑定与数字藏品获取的行为组合, 悬停查看详情',
    behaviorFeature: '行为特征',
    behaviorBasicDesc: '仅完成注册, 未绑定设备、未获取数字藏品',
    behaviorDeviceOnlyDesc: '已绑定设备, 未获取数字藏品',
    behaviorOnlineOnlyDesc: '未绑定设备, 已获取数字藏品',
    behaviorFullDesc: '已绑定设备且获取数字藏品的完整深度用户',
    userSegmentationTip: '基于时间范围内活跃数据划分深度活跃/浅活跃/新注册未活跃/流失用户, 悬停扇区可查看用户数量与行为特征',
    segDeepDesc: '区间内单日最大动作数≥3, 互动深度高',
    segShallowDesc: '区间内有过活跃, 但单日动作数<3',
    segNewInactiveDesc: '区间内新注册, 尚未产生活跃行为',
    segChurnedDesc: '老用户在区间内无任何活跃行为',
    funnelLayerUsers: '漏斗层用户',
    funnelCohortTip: '以时间范围内注册的新用户为队列, 追踪其后续转化; 点击漏斗层可查看用户列表',
    funnelCohortRangeTip: '注册队列区间: {start} ~ {end}',
    dialogUserId: '用户ID',
    dialogUsername: '用户名',
    dialogName: '姓名',
    dialogUserLevel: '等级',
    dialogPoints: '积分',
    dialogRegisterDate: '注册时间',
    // ---- 产品数据分析 ----
    nfcHourlyDist: '刷卡时段分布',
    nfcHourlyDistTip: '24小时刷卡量直方图, 与使用趋势时间范围联动',
    productRankingDesc: '按NFC绑定、刷卡频次或用户使用产品次数Top10, 与使用趋势时间范围联动',
    noUserDetailPermission: '暂无查看用户详情的权限',
    firmwareDistDesc: '设备固件版本占比与OTA升级渗透率概览, 全量统计不受时间范围影响',
    otaPenetration: 'OTA升级渗透率',
    otaPenetrationTip: '已升级至最新固件版本的设备占比',
    otaLatest: '最新版本',
    otaLatestCount: '最新版本设备数',
    otaTotalCount: '设备总数',
    // ---- 徽章活动分析 ----
    badgeSourceDist: '徽章类型发放分布',
    badgeSourceDistTip: '按徽章类型分组的每日发放量堆叠趋势, 与发放趋势时间范围联动',
    stackedByType: '按类型堆叠',
    badgeFunnelDesc: '按持有有效徽章数量分层的用户集齐进度, 全量统计; 点击漏斗层可查看用户列表',
    badgeRankingDesc: '时间范围内发放量最高的徽章Top10, 与发放趋势时间范围联动',
    funnelBadgeUsersTip: '统计口径: 当前持有该数量及以上有效徽章的用户',
    // ---- 积分权益分析 ----
    pointsAnalysis: '积分权益分析',
    pointsAnalysisDesc: '积分获取消耗与流转结构全景, 权益兑换转化与过期预警',
    pointsTotalEarn: '积分获取总量',
    pointsTotalSpend: '积分消耗总量',
    pointsNetInflow: '积分净流入',
    pointsExchangeUsers: '兑换用户数',
    pointsTrend: '每日获取与消耗趋势',
    pointsTrendTip: '时间范围内每日积分获取与消耗量对比',
    pointsEarn: '积分获取',
    pointsSpend: '积分消耗',
    pointsStructure: '积分流转结构',
    pointsStructureTip: '获取来源与消耗去向分布',
    pointsEarnSources: '获取来源',
    pointsEarnSourcesTip: '按来源类型统计的获取积分构成',
    pointsSpendTargets: '消耗去向',
    pointsSpendTargetsTip: '按去向类型统计的消耗积分构成',
    exchangeRanking: '权益兑换排行',
    exchangeTimesUnit: '次',
    exchangePointsCost: '消耗积分',
    exchangeFunnel: '兑换转化漏斗',
    exchangeFunnelTip: '获取过积分 → 积分达标 → 实际兑换',
    pointsExpiryWarning: '积分过期预警',
    pointsExpiryTip: '未来90天到期积分量(按日)',
    pointsExpiryAmount: '到期积分量',
    pointsExpiryEmpty: '未来90天暂无到期积分',
    sourceNfcBind: 'NFC刷卡获取',
    sourceManualAdd: '手动增加',
    sourceBatchAdd: '批量发放',
    sourceExchange: '权益兑换',
    sourceManualDeduct: '手动扣除',
    sourceExchangeRefund: '兑换退回',
    sourceOther: '其他'
  },
  auth: {
    login: '登录',
    register: '注册',
    registerSubtitle: '创建一个新账号',
    forgotPassword: '忘记密码',
    forgotPasswordSubtitle: '输入您的手机号以重置密码',
    resetPassword: '重置密码',
    resetPasswordSubtitle: '为您的账号设置新密码',
    userId: '用户ID',
    enterUsername: '请输入用户名',
    usernamePlaceholder: '请输入用户名',
    accountPlaceholder: '请输入用户名/手机号/邮箱',
    accountRequired: '请输入登录账号',
    username: '用户名',
    phone: '手机号',
    enterPhone: '请输入手机号',
    phoneRequired: '手机号不能为空',
    phoneInvalid: '请输入有效的手机号',
    smsCaptcha: '短信验证码',
    enterSmsCaptcha: '请输入短信验证码',
    smsCaptchaRequired: '短信验证码不能为空',
    sendSms: '发送验证码',
    smsSentSuccess: '验证码已发送',
    name: '姓名',
    enterName: '请输入姓名',
    email: '邮箱',
    enterEmail: '请输入邮箱',
    password: '密码',
    enterPassword: '请输入密码',
    passwordPlaceholder: '请输入密码',
    newPassword: '新密码',
    enterNewPassword: '请输入新密码',
    confirmPassword: '确认密码',
    confirmNewPassword: '确认新密码',
    captcha: '验证码',
    enterCaptcha: '请输入验证码',
    captchaPlaceholder: '请输入验证码',
    refreshCaptcha: '刷新验证码',
    getCaptcha: '获取验证码',
    refreshCaptchaTooltip: '点击刷新验证码',
    getCaptchaError: '获取验证码失败',
    usernameRequired: '用户名不能为空',
    usernameLength: '用户名长度应为3-20个字符',
    usernamePattern: '用户名只能包含字母、数字、下划线和连字符',
    nameRequired: '姓名不能为空',
    nameLength: '姓名长度应为2-50个字符',
    emailRequired: '邮箱不能为空',
    emailPattern: '请输入有效的邮箱地址',
    passwordRequired: '密码不能为空',
    newPasswordRequired: '新密码不能为空',
    passwordLength: '密码长度应为6-20个字符',
    confirmPasswordRequired: '确认密码不能为空',
    passwordNotMatch: '两次输入的密码不一致',
    captchaRequired: '验证码不能为空',
    backToLogin: '返回登录',
    haveAccount: '已有账号？',
    registerSuccess: '注册成功！',
    registerError: '注册失败，请重试。',
    forgotPasswordSuccess: '密码重置邮件发送成功！',
    forgotPasswordError: '发送重置邮件失败，请重试。',
    resetEmailSent: '密码重置邮件发送成功！',
    resetPasswordSuccess: '密码重置成功！',
    resetPasswordError: '密码重置失败，请重试。',
    invalidResetLink: '无效或已过期的重置链接。',
    invalidResetToken: '无效或已过期的重置令牌。',
    validateTokenError: '验证重置令牌失败。',
    rememberMe: '记住我',
    loginButton: '登录',
    orLoginWith: '或使用以下方式登录',
    loginTitle: '欢迎登录',
    loginSubtitle: '请输入您的账号信息',
    captchaLength: '验证码长度应为5个字符',
    usernameInvalid: '用户名格式不正确',
    // 具体的登录错误消息
    loginFailed: '登录失败',
    accountPasswordError: '用户名或密码错误',
    passwordLengthError: '密码长度错误',
    passwordWeakError: '密码强度不足',
    captchaError: '验证码错误，请重新输入',
    captchaExpired: '验证码已过期，请重新获取',
    captchaNotFound: '验证码不存在，请重新获取',
    captchaMismatch: '验证码不匹配，请重新输入',
    accountDisabled: '账号已被禁用',
    accountLocked: '账户已被锁定',
    encryptFailed: '加密失败，请重试',
    loginSuccess: '登录成功',
    networkError: '网络连接错误',
    serverError: '服务器错误',
    unknownError: '未知错误'
  },
  error: {
    pageNotFound: '抱歉，您访问的页面不存在',
    backHome: '返回首页'
  },
  icons: {
    menu: '菜单',
    mobile: '手机',
    connection: '连接',
    folder: '文件夹',
    document: '文件',
    location: '位置',
    time: '时间',
    setting: '设置',
    star: '收藏',
    picture: '图片',
    camera: '相机',
    headset: '耳机',
    mic: '麦克风',
    phone: '电话',
    printer: '打印机',
    refresh: '刷新',
    back: '返回',
    forward: '前进',
    left: '向左',
    right: '向右',
    down: '向下',
    up: '向上',
    dLeft: '双左',
    dRight: '双右',
    position: '坐标',
    upload: '上传',
    download: '下载',
    loading: '加载',
    view: '查看',
    scale: '缩放',
    sort: '排序',
    sortUp: '升序',
    sortDown: '降序',
    finished: '完成',
    more: '更多'
  },
  userManagement: {
    userList: '用户列表',
    createUser: '添加用户',
    userListTips: '管理系统用户信息，支持多维度查询与权限精细化配置',
    userGroupListTips: '定义用户分组架构，实现基于群组的权限统一分发与管理',
    manageDesc: '管理系统用户信息、角色及状态',
    userDetail: '用户详情',
    editUser: '编辑用户',
    userId: '用户ID',
    username: '用户名',
    enterUsername: '请输入用户名',
    usernameRequired: '用户名不能为空',
    usernameLength: '用户名长度为3-64个字符',
    usernamePattern: '用户名只能包含字母、数字、下划线和连字符',
    userIdRequired: '用户ID不能为空',
    userIdLength: '用户ID长度为3-32个字符',
    userIdPattern: '用户ID只能包含字母、数字、下划线和连字符',
    name: '姓名',
    inputName: '请输入姓名',
    nameRequired: '姓名不能为空',
    nameLength: '姓名长度为2-50个字符',
    email: '邮箱',
    inputEmail: '请输入邮箱',
    enterEmail: '请输入邮箱',
    emailRequired: '邮箱不能为空',
    emailPattern: '请输入有效的邮箱地址',
    phone: '手机号',
    enterPhone: '请输入手机号',
    phoneRequired: '手机号不能为空',
    phoneInvalid: '请输入有效的手机号',
    password: '密码',
    inputPassword: '请输入密码',
    enterPassword: '请输入密码',
    passwordRequired: '密码不能为空',
    passwordLength: '密码长度为6-32个字符',
    confirmPassword: '确认密码',
    confirmPasswordRequired: '确认密码不能为空',
    passwordNotMatch: '两次输入的密码不一致',
    newPassword: '新密码',
    inputNewPassword: '请输入新密码',
    confirmNewPassword: '确认新密码',
    role: '角色',
    selectRole: '请选择角色',
    roleRequired: '角色不能为空',
    groupRequired: '分组不能为空',
    admin: '管理员',
    user: '普通用户',
    status: '状态',
    active: '启用',
    inactive: '停用',
    inUse: '使用中',
    cancelled: '已注销',
    frozen: '已冻结',
    freeze: '冻结',
    unfreeze: '解冻',
    cancelAccount: '注销',
    gender: '性别',
    male: '男',
    female: '女',
    unknown: '保密',
    userLevel: '用户等级',
    userLevelNormal: '普通用户',
    userLevelVIP: 'VIP会员',
    userLevelSVIP: 'SVIP会员',
    roleSuperAdmin: '超级管理员',
    roleAdmin: '管理员',
    roleUser: '普通用户',
    roleUnknown: '未知角色',
    accountBalance: '账户余额',
    points: '用户积分',
    serviceExpiryDate: '有效期',
    selectExpiryDate: '请选择有效期',
    month: '个月',
    customMonth: '自定义月数',
    quickAdd: '快捷增加',
    addMonth: '增加{count}个月',
    selectUserLevel: '请选择用户等级',
    userLevelRequired: '用户等级不能为空',
    accountBalanceRequired: '账户余额不能为空',
    svip: 'SVIP',
    vip: 'VIP',
    normal: '普通',
    basicInfo: '基本信息',
    passwordSettings: '密码设置',
    userNotFound: '用户不存在',
    searchDevice: '搜索设备',
    bindDevice: '绑定设备',
    deviceName: '设备名称',
    deviceType: '型号',
    bindTime: '绑定时间',
    confirmUnbind: '确定要解绑设备 "{name}" 吗？',
    oldPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    oldPasswordRequired: '当前密码不能为空',
    newPasswordRequired: '新密码不能为空',
    confirmPasswordRequired: '确认新密码不能为空',
    changePassword: '修改密码',
    changePasswordSuccess: '密码修改成功',
    changePasswordError: '密码修改失败',
    loadingDevices: '正在加载设备列表...',
    fetchDevicesError: '加载设备列表失败',
    noDevices: '该用户暂未绑定任何设备',
    createSuccess: '用户创建成功',
    createError: '用户创建失败',
    updateSuccess: '用户更新成功',
    updateError: '用户更新失败',
    deleteConfirm: '确定要删除用户 {username} 吗？',
    deleteSuccess: '用户删除成功',
    deleteError: '用户删除失败',
    enableSuccess: '用户启用成功',
    disableSuccess: '用户禁用成功',
    statusChangeError: '状态变更失败',
    fetchRoleError: '获取角色列表失败',
    noRolePermission: '无权限获取角色列表，角色将保持不变',
    noPermissionView: '无权限查看该用户信息',
    batchDeleteConfirm: '确定要批量删除 {count} 个用户吗？',
    batchDeleteSuccess: '批量删除成功',
    batchDeleteError: '批量删除失败',
    batchEnableSuccess: '批量启用成功',
    batchDisableSuccess: '批量禁用成功',
    batchStatusChangeError: '批量状态变更失败',
    cannotDeleteAdmin: '不能删除管理员账户',
    cannotDisableAdmin: '不能禁用管理员账户',
    cannotChangeCancelledStatus: '已注销用户状态不可更改',
    searchUsername: '搜索用户名',
    searchEmail: '搜索邮箱',
    searchMobile: '搜索手机号',
    filterByGroup: '按分组筛选',
    filterByStatus: '按状态筛选',
    filterByType: '按类型筛选',
    filterByModel: '按型号筛选',
    userAgents: '关联智能体',
    searchAgent: '搜索智能体名称/编码',
    noAgents: '该用户暂未关联任何智能体',
    confirmExportUsers: '确定要导出用户列表吗？',
    selectedCount: '已选择 {count} 个用户',
    enableSelected: '启用选中用户',
    disableSelected: '禁用选中用户',
    deleteSelected: '删除选中用户',
    deleteSelectedGroup: '删除选中分组',
    assignUsersToGroupDesc: '确定要将选中的 {count} 个用户分配到分组吗？',
    selectUserGroup: '请选择用户分组',
    selectUserFirst: '请先选择要操作的用户',
    batchGroupOperation: '分组批量操作',
    groupBatchOperation: '分组批量操作',
    groupBatchOperationDesc: '将对分组 "{groupName}" 中的 {count} 个用户执行批量操作',
    enableGroupUsers: '启用分组用户',
    disableGroupUsers: '禁用分组用户',
    deleteGroupUsers: '删除分组用户',
    groupBatchEnableSuccess: '分组用户启用成功',
    groupBatchDisableSuccess: '分组用户禁用成功',
    groupBatchStatusChangeError: '分组用户状态变更失败',
    noValidUsers: '没有有效的用户执行操作',
    searchUsernameOrEmail: '搜索用户名或邮箱',
    searchGroupName: '搜索分组名称',
    enterUsernameOrEmail: '请输入用户名或邮箱',
    groupList: '用户分组列表',
    groupDetail: '用户分组详情',
    userGroups: '用户分组',
    createGroup: '创建用户分组',
    editGroup: '编辑用户分组',
    groupName: '分组名称',
    enterGroupName: '请输入分组名称',
    groupNameRequired: '分组名称不能为空',
    groupNameLength: '分组名称长度为2-64个字符',
    groupDescriptionLength: '分组描述长度不能超过200个字符',
    description: '分组描述',
    enterDescription: '请输入分组描述',
    enterGroupDescription: '请输入分组描述',
    memberCount: '成员数量',
    groupUserRequired: '请至少选择一个用户',
    assignedUsers: '分配用户',
    selectUsersToAssign: '请选择要分配的用户',
    userSelectionHint: '可搜索用户名或邮箱进行选择',
    searchUserHint: '可搜索用户名或邮箱进行选择',
    groupCreateSuccess: '分组创建成功',
    groupCreateError: '分组创建失败',
    groupUpdateSuccess: '分组更新成功',
    groupUpdateError: '分组更新失败',
    groupDeleteSuccess: '分组删除成功',
    groupDeleteError: '分组删除失败',
    deleteGroupConfirm: '确定要删除分组 {name} 吗？',
    deleteGroupSuccess: '删除分组成功',
    deleteGroupError: '删除分组失败',
    batchDeleteGroupConfirm: '确定要批量删除 {count} 个分组吗？',
    batchDeleteGroupSuccess: '批量删除分组成功',
    batchDeleteGroupError: '批量删除分组失败',
    selectedGroupCount: '已选择 {count} 个分组',
    groupMembers: '分组成员',
    addUsers: '添加用户',
    addUsersToGroup: '添加用户到分组',
    addSelected: '添加所选用户',
    addUsersSuccess: '添加用户成功',
    addUsersError: '添加用户失败',
    removeUserFromGroupConfirm: '确定要将用户 {username} 从分组中移除吗？',
    removeUserSuccess: '移除用户成功',
    removeUserError: '移除用户失败',
    batchRemoveUsersConfirm: '确定要移除选中的 {count} 个用户吗？',
    removeSelected: '移除选中用户',
    batchRemoveUsersSuccess: '批量移除用户成功',
    batchRemoveUsersError: '批量移除用户失败',
    updateUserStatusSuccess: '用户状态更新成功',
    updateUserStatusError: '用户状态更新失败',
    selectGroup: '选择分组',
    pleaseSelectUsers: '请选择要添加的用户',
    userBasicInfo: '用户基本信息',
    activitySummary: '活动概览',
    dataOverview: '数据概览',
    memorialCount: '纪念记录',
    noGroups: '该用户暂未加入任何分组',
    noLogs: '暂无操作日志',
    groupCount: '用户分组数量',
    deviceCount: '智能设备数量',
    peripheralCount: 'NFC周边数量',
    lastLogin: '最后登录',
    userDevices: '智能设备',
    userOperationLogs: '用户操作日志',
    viewAllLogs: '查看所有日志',
    neverLogin: '从未登录',
    users: '用户',
    fetchError: '获取用户列表失败',
    fetchErrorDetailed: '无法获取用户列表，服务器内部错误（500）',
    fetchGroupError: '获取用户分组失败',
    fetchGroupErrorDetailed: '无法获取用户分组，服务器内部错误（500）',
    bindDevicesSuccess: '设备绑定成功',
    bindDevicesError: '设备绑定失败',
    bindSelectedDevices: '绑定选中设备',
    operationType: '操作类型',
    removeFromGroup: '从分组移除',
    noDescription: '无描述',
    avatar: '头像',
    uploadAvatar: '上传头像',
    cropAvatar: '裁剪头像',
    selectDefaultAvatar: '选择默认头像',
    selectImageTip: '请选择图片文件',
    avatarSizeTip: '请上传图片并裁剪为 128*128 正方形',
    uploadError: '头像上传失败',
    userDetail: '用户详情',
    confirmUnbind: '确定要解绑该设备吗？',
    fetchDevicesError: '获取设备列表失败',
    expired: '已过期'
  },
  dictManagement: {
    pageTitle: '字典管理',
    searchPlaceholder: '请输入字典类型或名称查询',
    search: '搜索',
    dictTypeName: '字典类型名称',
    dictTypeCode: '字典类型编码',
    operation: '操作',
    edit: '编辑',
    dictLabel: '字典标签',
    dictValue: '字典值',
    sort: '排序',
    delete: '删除',
    selectAll: '全选',
    deselectAll: '取消全选',
    addDictType: '新增字典类型',
    batchDeleteDictType: '批量删除字典类型',
    addDictData: '新增字典数据',
    batchDeleteDictData: '批量删除字典数据',
    itemsPerPage: '{items}条/页',
    firstPage: '首页',
    prevPage: '上一页',
    nextPage: '下一页',
    totalRecords: '共{total}条记录',
    editDictType: '编辑字典类型',
    editDictData: '编辑字典数据',
    saveSuccess: '保存成功',
    deleteSuccess: '删除成功',
    selectDictTypeToDelete: '请选择要删除的字典类型',
    confirmDeleteDictType: '确定要删除选中的字典类型吗?',
    confirm: '确定',
    cancel: '取消',
    selectDictTypeFirst: '请先选择字典类型',
    confirmDeleteDictData: '确定要删除该字典数据吗?',
    selectDictDataToDelete: '请选择要删除的字典数据',
    confirmBatchDeleteDictData: '确定要删除选中的{count}个字典数据吗?',
    getDictDataFailed: '获取字典数据失败',
    dictTypeRequired: '字典类型不能为空',
    dictNameRequired: '字典名称不能为空',
    dictLabelRequired: '字典标签不能为空',
    dictValueRequired: '字典值不能为空'
  },
  otaManagement: {
    firmwareManagement: '固件管理',
    firmwareManagementTips: '管理并分发设备固件包，支持多版本追踪、增量升级及安全 OTA 推送',
    searchPlaceholder: '搜索固件名称',
    search: '搜索',
    firmwareName: '固件名称',
    firmwareType: '固件类型',
    version: '版本号',
    fileSize: '文件大小',
    remark: '备注',
    createTime: '创建时间',
    updateTime: '更新时间',
    actions: '操作',
    download: '下载',
    edit: '编辑',
    delete: '删除',
    selectAll: '全选',
    deselectAll: '取消全选',
    addNew: '新增固件',
    addFirmware: '新增固件',
    editFirmware: '编辑固件',
    itemsPerPage: '{items}条/页',
    firstPage: '首页',
    prevPage: '上一页',
    nextPage: '下一页',
    totalRecords: '共{total}条记录',
    selectFirmwareFirst: '请先选择需要删除的固件',
    confirmBatchDelete: '确定要删除选中的{paramCount}个固件吗？',
    operationCancelled: '已取消删除操作',
    operationClosed: '操作已关闭',
    batchDeleteSuccess: '成功删除{paramCount}个固件',
    deleteFailed: '删除失败，请重试',
    incompleteFirmwareInfo: '固件信息不完整',
    getDownloadUrlFailed: '获取下载链接失败',
    getFirmwareTypesFailed: '获取固件类型失败',
    updateSuccess: '修改成功',
    updateFailed: '修改失败',
    addSuccess: '添加成功',
    addFailed: '新增失败',
    fetchFirmwareListFailed: '获取固件列表失败',
    invalidFirmwareId: '无效的固件ID',
    downloadTitle: '固件下载',
    remainingTime: '剩余时间',
    downloading: '正在下载...',
    paused: '已暂停',
    completed: '下载完成',
    failed: '下载失败'
  },
  firmwareDialog: {
    firmwareName: '固件名称',
    firmwareNamePlaceholder: '请输入固件名称(板子+版本号)',
    firmwareType: '固件类型',
    firmwareTypePlaceholder: '请选择固件类型',
    version: '版本号',
    versionPlaceholder: '请输入版本号(x.x.x格式)',
    firmwareFile: '固件文件',
    clickUpload: '点击上传',
    uploadTip: '只能上传固件文件(.bin/.apk/.wav)，且不超过100MB',
    uploadHint: '温馨提示：请上传合并前的agent.bin文件，而不是合并后的merged-binary.bin文件',
    remark: '备注',
    remarkPlaceholder: '请输入备注信息',
    requiredFirmwareName: '请输入固件名称',
    requiredFirmwareType: '请选择固件类型',
    requiredVersion: '请输入版本号',
    versionFormatError: '版本号格式不正确，请输入x.x.x格式',
    requiredFirmwareFile: '请上传固件文件',
    invalidFileType: '只能上传.bin/.apk/.wav格式的文件!',
    invalidFileSize: '文件大小不能超过100MB!',
    uploadSuccess: '文件上传成功',
    uploadFailed: '文件上传失败'
  },
  providerManagement: {
    pageTitle: '供应器管理',
    categoryFilter: '类别筛选',
    searchPlaceholder: '请输入供应器名称查询',
    category: '类别',
    providerCode: '供应器编码',
    fieldConfig: '字段配置',
    selectToDelete: '请先选择需要删除的供应器',
    confirmDelete: '确定要删除选中的{count}个供应器吗？',
    viewFields: '查看字段',
    all: '全部',
    modelType: {
      ASR: '语音识别',
      TTS: '语音合成',
      LLM: '大语言模型',
      VLLM: '视觉大语言模型',
      INTENT: '意图识别',
      MEMORY: '记忆模块',
      VAD: '语音活动检测',
      PLUGIN: '插件工具',
      RAG: '知识库'
    }
  },
  providerDialog: {
    category: '类别',
    selectCategory: '请选择类别',
    code: '编码',
    inputCode: '请输入供应器编码',
    name: '名称',
    inputName: '请输入供应器名称',
    sort: '排序',
    fieldConfig: '字段配置',
    add: '添加字段',
    deselectAll: '取消全选',
    selectAll: '全选',
    batchDelete: '批量删除',
    fieldKey: '字段key',
    fieldLabel: '字段标签',
    fieldType: '字段类型',
    type: '类型',
    stringType: '字符串',
    numberType: '数字',
    booleanType: '布尔值',
    dictType: '字典',
    arrayType: '分号分割的列表',
    ragType: '知识库',
    defaultValue: '默认值',
    inputDefaultValue: '请输入默认值',
    operation: '操作',
    edit: '编辑',
    complete: '完成',
    delete: '删除',
    save: '保存',
    requiredCategory: '请选择类别',
    requiredCode: '请输入供应器编码',
    requiredName: '请输入供应器名称',
    completeFieldEdit: '请先完成当前字段的编辑',
    confirmDeleteField: '确定要删除该字段吗？',
    selectFieldsToDelete: '请先选择要删除的字段',
    confirmBatchDeleteFields: '确定要删除选中的{count}个字段吗？',
    batchDeleteFieldsSuccess: '成功删除{count}个字段'
  },
  paramManagement: {
    pageTitle: '参数管理',
    searchPlaceholder: '请输入参数编码或备注查询',
    search: '搜索',
    paramCode: '参数编码',
    paramValue: '参数值',
    valueType: '值类型',
    paramType: '参数类型',
    systemParam: '系统参数',
    nonSystemParam: '普通参数',
    remark: '备注',
    operation: '操作',
    hide: '隐藏',
    view: '查看',
    deselectAll: '取消全选',
    selectAll: '全选',
    add: '新增',
    delete: '删除',
    edit: '编辑',
    itemsPerPage: '条/页',
    firstPage: '首页',
    prevPage: '上一页',
    nextPage: '下一页',
    totalRecords: '共{total}条记录',
    addParam: '新增参数',
    editParam: '编辑参数',
    getParamsListFailed: '获取参数列表失败',
    selectParamsFirst: '请先选择需要删除的参数',
    confirmBatchDelete: '确定要删除选中的{paramCount}个参数吗？',
    invalidParamId: '存在无效的参数ID',
    batchDeleteSuccess: '成功删除{paramCount}个参数',
    deleteFailed: '删除失败，请重试',
    operationCancelled: '已取消删除操作',
    operationClosed: '操作已关闭',
    updateSuccess: '修改成功',
    addSuccess: '新增成功',
    updateFailed: '更新失败',
    addFailed: '新增失败',
    paramCodeRequired: '参数编码不能为空',
    paramValueRequired: '参数值不能为空',
    valueTypeRequired: '请选择值类型'
  },
  device: {
    deviceManagement: '设备管理',
    deviceManagementSubtitle: '管理您的所有设备',
    deviceListTips: '实时监控已连接设备，支持状态追踪与远程维护功能',
    deviceList: '设备列表',
    deviceDetail: '设备详情',
    deviceAdd: '添加设备',
    deviceEdit: '编辑设备',
    bindDevice: '绑定设备',
    unbindDevice: '解绑设备',
    unbind: '解绑',
    searchPlaceholder: '搜索设备名称/MAC',
    board: '型号',
    bindTime: '绑定时间',
    enterDeviceCode: '请输入设备激活码',
    deviceCodePlaceholder: '输入设备背后的激活码或ID',
    deviceLogs: '设备日志',
    getLogsFailed: '获取设备日志失败',
    deviceName: '设备名称',
    deviceNamePlaceholder: '请输入设备名称',
    deviceCode: '设备编码',
    deviceType: '设备类型',
    deviceTypePlaceholder: '请选择设备类型',
    smartDevice: '智能设备',
    peripheral: '周边设备',
    deviceModel: '设备型号',
    firmwareVersion: '固件版本',
    macAddress: 'MAC地址',
    manufacturer: '生产商',
    onlineStatus: '在线状态',
    bindingStatus: '绑定状态',
    activationState: '激活状态',
    bindUser: '绑定用户',
    belongToUser: '归属用户',
    bound: '已绑定',
    unbound: '未绑定',
    signalStrength: '信号强度',
    batteryLevel: '电量',
    bindingSuccess: '设备绑定成功',
    bindingError: '设备绑定失败',
    unbindingSuccess: '设备解绑成功',
    unbindingError: '设备解绑失败',
    unbindSuccess: '设备解绑成功',
    unbindFailed: '设备解绑失败',
    lastConversation: '最后通话',
    remarks: '备注',
    enterRemarks: '请输入备注',
    unbindDeviceConfirm: '确定要解绑设备 {name} 吗？',
    deviceInfo: '设备信息',
    deviceBasicInfo: '基础信息',
    deviceRemark: '设备备注',
    autoUpdate: '自动更新',
    batchNo: '批次号',
    lifecycleStatus: '生命周期状态',
    activationTime: '激活时间',
    lifecycleCreated: '已创建',
    lifecycleProduction: '生产中',
    lifecycleWarehouse: '已入库',
    lifecycleShipped: '已出货',
    lifecycleActivated: '已激活',
    lifecyclePending: '待激活',
    unactivated: '未激活',
    deviceCodeFilter: '设备编码(UUID)',
    deviceCodeFilterPlaceholder: '请输入设备编码(UUID)',
    lastOnlineTime: '最后上线时间',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    online: '在线',
    offline: '离线',
    ownerName: '所有者',
    deviceModelPlaceholder: '请选择设备型号',
    firmwareVersionPlaceholder: '请输入固件版本',
    manufacturerPlaceholder: '请输入生产商',
    ownerNamePlaceholder: '请选择所有者',
    deviceRemarkPlaceholder: '请输入设备备注',
    macAddressPlaceholder: '请输入设备MAC地址',
    macAddressRequired: '请输入设备MAC地址',
    invalidMacAddress: '请输入有效的MAC地址',
    deviceNameRequired: '请输入设备名称',
    deviceNameLength: '设备名称长度不能超过50个字符',
    userIdRequired: '请选择所有者',
    macAddressFormat: 'MAC地址格式不正确',
    deviceModelRequired: '请选择设备型号',
    deviceCodeRequired: '请输入设备编码',
    firmwareVersionRequired: '请输入固件版本',
    firmwareVersionFormat: '固件版本格式不正确',
    addConfirm: '确定要添加该设备吗？',
    saveConfirm: '确定要保存修改吗？',
    fetchDeviceDetailFailed: '获取设备详情失败',
    fetchUserListFailed: '获取用户列表失败',
    updateDeviceSuccess: '设备信息更新成功',
    updateDeviceFailed: '设备信息更新失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    boundAt: '绑定时间',
    getDeviceDetailFailed: '获取设备详情失败',
    deviceStatusMonitor: '设备状态监控',
    operationTime: '操作时间',
    operatorName: '操作人',
    enterOperatorName: '请输入操作人姓名',
    logId: '日志ID',
    operationDesc: '操作描述',
    deviceMac: '设备MAC',
    operationStatus: '状态',
    confirmExportLogs: '确定要导出设备日志吗？',
    exportLogsSuccess: '日志导出成功',
    exportLogsFailed: '日志导出失败',
    deviceBind: '设备绑定',
    deviceUnbind: '设备解绑',
    deviceUpdate: '设备更新',
    firmwareUpdate: '固件升级',
    firmwareUpgrade: '固件升级',
    basicInfo: '基本信息',
    otherInfo: '其他信息',
    deviceRestart: '设备重启',
    configChange: '配置变更',
    version: '版本',
    statusInfo: '状态信息',
    deviceOperations: '设备操作',
    logType: '日志类型',
    logDescription: '日志内容',
    logAction: '操作动作',
    logOperator: '操作人',
    viewLogs: '查看日志',
    recentLogs: '最近日志',
    firmwareUpgradeDesc: '升级过程中请勿断开设备电源或关闭网络连接。',
    currentVersion: '当前版本',
    targetVersion: '目标版本',
    selectVersion: '请选择目标版本',
    upgradeNotes: '升级备注',
    upgradeNotesPlaceholder: '请输入本次升级的备注信息',
    upgradeProgress: '升级进度',
    startUpgrade: '开始升级',
    allLogs: '全部日志',
    operationLog: '操作日志',
    statusLog: '状态日志',
    errorLog: '错误日志',
    unknownLog: '未知日志',
    bindDeviceDesc: '确定要将设备 {name} 绑定给指定用户吗？',
    selectUser: '选择用户',
    bindNotes: '绑定备注',
    bindNotesPlaceholder: '请输入绑定备注',
    bindSuccess: '绑定成功',
    bindFailed: '绑定失败',
    upgradeStart: '升级指令已发送',
    upgradeSuccess: '升级成功',
    upgradeFailed: '升级失败',
    versionRequired: '请输入版本号',
    agentId: '智能体ID',
    creator: '创建人',
    updater: '更新人'
  },
  permissionManagement: {
    title: '权限管理',
    permissionManagementTips: '维护系统功能树与接口授权标识，定义全局权限元数据及资源映射关系',
    searchPlaceholder: '输入名称或路径搜索',
    expandAll: '全部展开',
    collapseAll: '全部折叠',
    batchOperation: '批量操作',
    checkAll: '全选',
    checkNone: '反选',
    expandLevel1: '仅展开一级',
    editPermission: '编辑权限',
    addPermission: '新增权限',
    associatedRoles: '关联角色',
    parentName: '上级权限',
    root: '根节点',
    name: '权限名称',
    type: '权限类型',
    directory: '目录',
    menu: '菜单',
    button: '按钮',
    url: '路由路径',
    permission: '权限标识',
    icon: '图标',
    sort: '排序权重',
    description: '详细描述',
    createTime: '创建时间',
    updateTime: '更新时间',
    pleaseSelectNode: '请从左侧选择权限项进行查看或编辑',
    nameRequired: '请输入名称',
    typeRequired: '请选择类型',
    permissionRequired: '请输入权限标识',
    fetchListError: '获取权限列表失败',
    unknown: '未知',
    deleteConfirm: '确定要删除权限"{name}"吗？如果包含子项则无法直接删除。',
    levelAdjustSuccess: '层级调整成功',
    levelAdjustError: '层级调整失败',
    quickFill: '快速填充',
    actionList: '列表 (list)',
    actionInfo: '详情 (info)',
    actionSave: '新增 (save)',
    actionUpdate: '修改 (update)',
    actionDelete: '删除 (delete)',
    actionView: '查看 (view)',
    permissionTip: '建议格式: sys:模块:动作 (例如 sys:user:save)',
    commonIcons: '常用图标',
    autoGenerateUrl: '自动生成URL',
    urlTip: '菜单对应的路由路径，如 /sys/user'
  },
  resourceManagement: {
    dashboard: '资源监控',
    resourceDashboardTips: '实时监控系统资源状态、模型调用分布及核心指标统计',
    resourceQuota: '资源配额',
    resourceQuotaTips: '监控和调整用户的资源额度，管理账户余额及消耗限制',
    quotaDetail: '配额详情',
    totalQuota: '配额总量',
    basicInfo: '基础信息',
    usageDetails: '使用明细',
    modelList: '模型列表',
    modelListTips: '管理系统支持的所有 AI 模型，配置厂商参数及运行状态',
    modelType: '模型类型',
    modelId: '模型ID',
    supplier: '供应器',
    docLink: '接口文档',
    remark: '备注',
    callInfo: '调用信息',
    modelInfo: '模型信息',
    selectSupplier: '请选择供应器',
    jsonFormatError: 'JSON格式错误，必须是一个对象',
    resourceUsage: '资源使用情况',
    cpuUsage: 'CPU使用率',
    memoryUsage: '内存使用率',
    storageUsage: '存储使用率',
    quotaExceeded: '配额已超出',
    usageTrend: '使用趋势',
    generateReport: '生成报告',
    reportGenerated: '报表生成成功',
    totalResources: '资源总额度',
    modelTotalResources: '模型商资源总量',
    userTotalResources: '用户分配总量',
    usedResources: '累计已使用量',
    userAvailableResources: '用户剩余可用',
    modelAvailableResources: '模型商剩余可用',
    normalOperationResources: '正常运行资源',
    resourceUsageWarning: '资源使用警告',
    resourceUsageAbnormal: '资源使用异常',
    computeResources: '计算资源',
    storageResources: '存储资源',
    networkResources: '网络资源',
    memoryResources: '内存资源',
    timeRange: '时间范围',
    chartType: '图表类型',
    lineChart: '折线图',
    barChart: '柱状图',
    resourceAlerts: '资源预警',
    alertType: '预警类型',
    alertTitle: '告警标题',
    alertDescription: '告警描述',
    alertLevel: '告警级别',
    info: '提示',
    warning: '警告',
    error: '错误',
    critical: '严重',
    concurrencyAlert: '并发预警',
    balanceAlert: '余额预警',
    anomalyAlert: '异常预警',
    usageAlert: '用量预警',
    modelQuotaAlert: '模型配额预警',
    userQuotaAlert: '用户配额预警',
    errorRateAlert: '错误率预警',
    checkNow: '立即检查',
    alertDetail: '告警详情',
    occurTime: '触发时间',
    modelName: '关联模型',
    viewModelDetail: '查看模型详情',
    userName: '关联用户',
    viewUserInfo: '查看用户信息',
    markAsResolved: '标记为已处理',
    alertCheckSuccess: '资源预警检查完成',
    alertCheckFailed: '手动触发预警检查失败',
    confirmClearAlerts: '确定清空所有已处理告警吗？',
    confirmResolveAlert: '确定将该告警标记为已处理吗？',
    statusUnprocessed: '待处理',
    statusIgnored: '已忽略',
    statusResolved: '已解决',
    enterProcessRemark: '请输入处理备注',
    remarkPlaceholder: '处理备注',
    alertProcessed: '告警已处理',
    confirmIgnoreAlert: '确定忽略该告警吗？',
    alertIgnored: '告警已忽略',
    resourceId: '资源ID',
    resourceName: '资源名称',
    currentValue: '当前值',
    threshold: '告警阈值 (%)',
    changeRate: '变化率',
    unprocessed: '未处理',
    processed: '已处理',
    utilizationTooHigh: '使用率过高',
    suddenIncreaseAbnormal: '突增异常',
    normalRunningResources: '正常运行资源',
    fetchOverviewFailed: '获取资源概览失败',
    fetchUsageFailed: '获取资源使用情况失败',
    fetchAlertListFailed: '获取告警列表失败',
    confirmProcessAlert: '确定要处理该告警吗？',
    userManualProcess: '用户手动处理',
    handleAlertFailed: '处理告警失败',
    ignoreAlertFailed: '忽略告警失败',
    realtimeUpdatesEnabled: '实时更新已开启',
    realtimeUpdatesDisabled: '实时更新已关闭',
    utilization: '使用率',
    abnormal: '异常',
    average: '平均值',
    resourceUsageTrend: '资源使用趋势',
    fetchAlertDetailFailed: '获取告警详情失败',
    realtimeOn: '实时更新中',
    realtimeOff: '实时更新已关闭',
    enableRealtimeUpdates: '启用实时数据更新',
    disableRealtimeUpdates: '关闭实时数据更新',
    realtimeUpdatesEnabled: '已启用实时数据更新',
    realtimeUpdatesDisabled: '已关闭实时数据更新',
    lastUpdateTime: '最后更新时间',
    availableResources: '剩余可用总量',
    utilizationRate: '资源消耗占比',
    quotaDistribution: '资源配额分布',
    modelUsageRatio: '模型使用分布',
    callCount: '调用次数',
    tokenConsumption: 'Token 消耗',
    granularity: '时间粒度',
    hour: '小时',
    day: '天',
    week: '周',
    month: '月',
    dataLabel: '数据标签',
    viewQuota: '查看配额',
    resourceUsageRanking: '资源使用排行',
    modelUsageRanking: '模型资源使用排行',
    userUsageRanking: '用户使用排行',
    tokensConsumed: 'Token 消耗',
    rank: '排名',
    usageAmount: '使用量',
    noUsageData: '暂无使用数据',
    businessType: '业务类型',
    bizChat: '对话',
    bizSTT: '语音识别',
    bizTTS: '语音合成',
    bizVAD: '端点检测',
    bizOCR: '图像识别',
    allocateQuota: '分配资源配额',
    editQuota: '编辑资源配额',
    quotaList: '资源配额列表',
    quotaValue: '总额度Token',
    usedValue: '已用数值',
    remainingValue: '剩余数值',
    limitLine: '限制线',
    warningLine: '预警线',
    viewUsage: '查看使用',
    resourceType: '资源类型',
    token: 'Token',
    resourceTypePlaceholder: '请选择资源类型',
    modelPlaceholder: '请选择或搜索模型',
    quotaValuePlaceholder: '请输入配额数值',
    quotaValueMin: '配额必须大于0',
    adjustSetting: '调整设置',
    filterCondition: '筛选条件',
    resetCycle: '重置周期',
    resetQuota: '自动重置额度',
    resetCyclePlaceholder: '请选择重置周期',
    effectiveTime: '生效时间',
    effectiveTimePlaceholder: '请选择生效时间',
    expiryTime: '失效时间',
    expiryTimePlaceholder: '请选择失效时间',
    batchEditQuota: '批量编辑配额',
    batchAdjust: '批量调整',
    batchPreview: '操作预览',
    adjustMode: '调整模式',
    fixedAdd: '固定额度增加',
    percentageAdd: '百分比额度增加',
    fixedSub: '固定额度减少',
    validity: '有效期',
    permanent: '永久',
    temporary: '临时',
    affectedUsers: '受影响用户',
    affectedQuotas: '受影响配额项',
    totalChange: '预计总变动',
    executeAdjust: '执行调整',
    selectGroups: '选择用户组',
    allUsers: '全部用户',
    regTimeRange: '注册时间范围',
    adjustType: '调整类型',
    leaveEmptyNoChange: '不填写则不修改',
    previewFailed: '预览失败',
    noPreviewConfirm: '尚未进行预览，是否直接执行调整？',
    noPreviewModifyConfirm: '尚未进行预览，是否直接执行修改？',
    executeDirectly: '直接执行',
    previewFirst: '先预览',
    batchAdjustSuccess: '批量调整成功',
    batchEditSuccess: '批量修改成功',
    executeFailed: '执行失败',
    none: '永不重置',
    daily: '按天重置',
    weekly: '按周重置',
    monthly: '按月重置',
    quarterly: '按季重置',
    yearly: '按年重置',
    deleteQuotaConfirm: '确定要删除该用户的{type}配额吗？',
    userPlaceholder: '请选择用户',
    quotaUpdateSuccess: '配额更新成功',
    quotaAllocateSuccess: '配额分配成功',
    quotaUpdateFailed: '配额更新失败',
    quotaAllocateFailed: '配额分配失败',
    quotaPolicy: '配额策略',
    userLevel: '用户等级',
    quotaPolicyTips: '定义不同用户等级的资源配额发放和重置规则',
    policyName: '策略名称',
    allocatedTokens: '分配额度',
    isUnlimited: '无限额度',
    unlimited: '无限',
    allowedModels: '允许使用的模型',
    allModels: '全部模型 (*)',
    selectModelsPlaceholder: '请选择模型 (不选则无权限)',
    monthlyReset: '每月重置',
    quotaLogs: '资源审计日志',
    quotaLogsTips: '查看资源配额的变动记录、审计流水及系统告警日志',
    alertLog: '异常预警记录',
    operationLog: '配额日志',
    transactionRecord: '额度收支流水',
    usageDetails: '资源消耗明细',
    amount: '变动额度',
    balance: '当前余额',
    operator: '操作人',
    targetUser: '目标用户',
    changeType: '变更类型',
    currentQuota: '变更后总配额',
    initQuota: '初始配额',
    manualAdjust: '管理员手动调整',
    manualBatchAdjust: '批量调整 (系统记录)',
    autoReset: '系统自动重置',
    policyApply: '策略规则下发',
    tokenConsume: 'Token资源消耗',
    monthlyResetAction: '周期额度重置',
    statusChange: '配额状态变更',
    fetchQuotaListFailed: '获取配额列表失败',
    tokenAllocation: 'Token分配',
    noAlerts: '暂无告警',
    noResourceAlerts: '暂无资源告警',
    provideCode: '提供商代码',
    isDefault: '是否默认',
    voiceList: '声音列表',
    addModel: '新增模型',
    editModel: '编辑模型',
    deleteModel: '删除模型',
    modelConfig: '模型配置',
    providerConfig: '提供商配置',
    llmModel: '大语言模型',
    ttsModel: '语音合成(TTS)',
    asrModel: '语音识别(ASR)',
    imgGenModel: '图像生成',
    searchModel: '搜索模型名称',
    confirmDeleteModel: '确定要删除该模型配置吗？',
    deleteModelSuccess: '删除模型成功',
    addModelSuccess: '添加模型成功',
    updateModelSuccess: '更新模型成功',
    alertLog: '告警日志',
    alertContent: '告警内容',
    alertStatus: '告警状态',
    ignored: '已忽略',
    resolved: '已解决',
    resolveTime: '处理时间',
    confirmIgnore: '确定要忽略该告警吗？',
    confirmResolve: '处理备注',
    resolveSuccess: '处理成功',
    ignoreSuccess: '忽略成功',
    modelQuota: '模型配额',
    userQuota: '用户配额',
    errorRate: '异常率',
    warning: '警告',
    critical: '严重',
    alertTitle: '告警标题',
    unsupportedExport: '当前标签页不支持导出',
    exportFailed: '导出失败',
    threshold: '告警阈值',
    enterThreshold: '请输入告警阈值(0-100)',
    sortOrder: '排序权重',
    sortOrderPlaceholder: '请输入排序权重（数字越小越靠前）',
    basicConfig: '基础配置',
    apiConfig: '接口配置',
    fetchModelListFailed: '获取模型列表失败',
    fetchProvidersFailed: '获取提供商列表失败',
    fetchVoicesFailed: '获取声音列表失败',
    removeSelected: '移除选中项',
    resourceReportTips: '多维度分析资源消耗趋势，生成可视化使用统计报告',
    generateReport: '生成报表',
    vsLastPeriod: '较上期',
    distributionDetails: '消耗分布详情',
    reportConfiguration: '报表配置',
    reportType: '报表类型',
    usageSummary: '使用汇总',
    trendAnalysis: '趋势分析',
    costAnalysis: '成本分析',
    forecastReport: '预测报告',
    resourceTypes: '资源类型',
    previewReport: '预览报表',
    reportPreview: '报表预览',
    resourceUsageReport: '资源使用报表',
    generateTime: '生成时间',
    overview: '概览',
    totalUsage: '总使用量',
    averageUsage: '平均使用量',
    peakUsage: '峰值使用量',
    totalCost: '总成本',
    usageTrends: '使用趋势',
    resourceDistribution: '资源分布',
    usage: '使用量',
    percentage: '百分比',
    cost: '成本',
    alertsAndEvents: '告警与事件',
    impact: '影响',
    highImpact: '高影响',
    mediumImpact: '中影响',
    lowImpact: '低影响',
    recommendations: '优化建议',
    optimization: '优化',
    manualProcess: '用户手动处理',
    dataUpdated: '数据已更新',
    modelProviderTips: '配置和管理不同厂商的模型供应器，集成多种 AI 能力',
    ASR_AliyunASR: '阿里云语音识别',
    ASR_AliyunStreamASR: '阿里云语音识别(流式)',
    ASR_DoubaoASR: '豆包语音识别'
  },
  roleManagement: {
    roleManagement: '角色管理',
    rolePermissionManagement: '角色权限管理',
    userRoleListTips: '构建基于角色的访问控制模型 (RBAC)，精细化管理页面访问与功能操作权限',
    expandAll: '全部展开',
    collapseAll: '全部折叠',
    checkAll: '全选',
    checkNone: '全不选',
    createRole: '创建角色',
    viewRole: '查看角色',
    viewRoleList: '查看角色列表和详情',
    createRolePermission: '创建角色和分配权限',
    editRole: '编辑角色',
    modifyRolePermission: '修改角色和权限配置',
    deleteRole: '删除角色',
    deleteRolePermission: '删除角色和相关权限',
    roleList: '角色列表',
    permissionConfiguration: '权限配置',
    savePermissions: '保存权限',
    pageAccessPermissions: '页面访问权限',
    operationButtonPermissions: '操作按钮权限',
    roleStatus: '角色状态',
    pleaseSelectRoleForConfig: '请选择角色进行权限配置',
    createRoleDialogTitle: '创建角色',
    editRoleDialogTitle: '编辑角色',
    roleName: '角色名称',
    enterRoleName: '请输入角色名称',
    roleNameRequired: '请输入角色名称',
    roleDescription: '角色描述',
    enterRoleDescription: '请输入角色描述',
    roleDescriptionRequired: '请输入角色描述',
    deleteRoleConfirm: '确定要删除角色"{roleName}"吗？',
    deleteNodeConfirm: '确定要删除节点"{name}"吗？',
    deleteRoleSuccess: '删除成功',
    createRoleSuccess: '创建成功',
    updateRoleSuccess: '更新成功',
    savePermissionsSuccess: '权限保存成功',
    savePermissionsError: '权限保存失败',
    superAdminAllPermissions: '超级管理员拥有所有权限，不可修改',
    noUsersInRole: '该角色下暂无用户',
    roleCode: '角色编码',
    autoGenerateHint: '系统自动生成',
    roleCodeAutoGenerateTip: '基于角色名称自动生成唯一编码，格式：ROLE_XXX_001',
    enterRoleCode: '请输入角色编码',
    dataScope: '数据权限范围',
    dataScopeAll: '全部数据',
    dataScopeGroup: '分组数据',
    dataScopeSelf: '个人数据',
    dataScopeAllTip: '提示：该角色可以查看系统内所有用户产生的数据。',
    dataScopeGroupTip: '提示：该角色可以查看所属分组内所有成员产生的数据。',
    dataScopeSelfTip: '提示：该角色仅能查看自己产生的数据。',
    pagesSelected: '个页面',
    buttonsSelected: '个按钮',
    selectMenuForButtons: '请先从上方树形结构中点击选择一个页面菜单，以配置其关联的操作按钮。',
    noButtonsForMenu: '该页面菜单没有配置关联的操作按钮。',
    menuNotCheckedTip: '当前页面未被勾选，请先勾选页面访问权限后再配置按钮权限。',
    orphanButtonsWarning: '以下按钮权限的父页面未被选中，已自动移除：{buttons}',
    deleteRoleWithUsersConfirm: '角色"{roleName}"下还有 {userCount} 个用户，删除后这些用户将失去该角色的权限。确定要删除吗？',
    permissionUpdateNotifyTitle: '提示',
    permissionUpdateNotifyMessage: '角色权限已更新，相关用户的权限缓存已清除，下次操作或重新登录时生效。',
    fetchRoleError: '获取角色列表失败',
    deleteRoleError: '删除角色失败',
    createRoleError: '创建角色失败',
    updateRoleError: '更新角色失败'
  },
  agent: {
    agentListTips: '智能体列表',
    createAgent: '创建智能体',
    editAgent: '编辑智能体',
    agentName: '智能体名称',
    agentCode: '智能体编码',
    agentCount: '智能体数量',
    userId: '用户ID',
    agentId: '智能体ID',
    quickStartTemplate: '从模板快速开始',
    selectTemplatePlaceholder: '请选择模板',
    corePersona: '核心人设',
    agentIdentity: '智能体身份',
    avatar: '智能体头像',
    uploadAvatar: '上传头像',
    avatarSizeTip: '建议 1:1 分辨率，支持 JPG/PNG/WEBP，不超过 2MB',
    enterAgentName: '请输入智能体名称',
    inputAgentName: '请输入智能体名称',
    roleDescription: '角色描述 (System Prompt)',
    systemPromptPlaceholder: '请输入系统提示词，定义智能体的角色、性格和行为规范...',
    summaryMemory: '记忆摘要',
    summaryMemoryPlaceholder: '请输入记忆摘要，帮助智能体记住重要的历史上下文...',
    capabilities: '能力与模型配置',
    capabilitiesTag: '核心配置',
    modelStack: '模型堆栈',
    llmModel: '大语言模型 (LLM)',
    vllmModel: '视觉模型 (VLLM)',
    asrModel: '语音识别 (ASR)',
    vadModel: '端点检测 (VAD)',
    memoryModel: '记忆模型',
    intentModel: '意图识别',
    voiceConfig: '语音合成配置',
    ttsModel: '语音合成 (TTS)',
    ttsVoice: '音色选择',
    selectTtsModelFirst: '请先选择 TTS 模型',
    advancedSettings: '高级设置',
    chatHistoryStrategy: '聊天记录存储策略',
    noRecord: '不记录',
    onlyText: '仅文本',
    textAndVoice: '文本与语音',
    extendedFeatures: '扩展功能',
    pluginConfig: '插件配置',
    chatHistoryQuery: '聊天记录查询',
    selectAgent: '选择智能体',
    templateManagement: '模板管理',
    createTemplate: '创建模板',
    editTemplate: '编辑模板',
    templateName: '模板名称',
    inputTemplateName: '请输入模板名称',
    allCategories: '全部分类',
    general: '通用',
    customerService: '客服',
    education: '教育',
    entertainment: '娱乐',
    others: '其他',
    category: '分类',
    selectCategory: '请选择分类',
    systemPrompt: '系统提示词',
    deploy: '部署',
    basicInfo: '基本信息',
    pluginManagement: '插件管理',
    pluginManagementTips: '集成并管理智能体的扩展功能插件，支持函数调用与三方服务对接',
    uploadPlugin: '上传插件',
    pluginName: '插件名称',
    pluginCode: '插件编码',
    pluginVersion: '插件版本',
    pluginType: '插件类型',
    pluginStatus: '插件状态',
    statusPublished: '已发布',
    statusPending: '待审核',
    statusDisabled: '已停用',
    audit: '审核',
    hotUpdate: '热更新',
    selectSession: '选择会话',
    pleaseSelectAgent: '请先选择左侧智能体',
    noSessions: '暂无会话记录',
    chatDetail: '聊天详情',
    pleaseSelectSession: '请选择会话',
    searchContent: '搜索聊天内容',
    filterSensitive: '过滤敏感词',
    messageCount: '{count} 条',
    pleaseSelectSessionOnLeft: '请选择左侧会话查看详情',
    noChatHistory: '暂无聊天记录',
    noDescription: '暂无描述',
    fetchAgentListFailed: '获取智能体列表失败',
    deleteConfirm: '确定要删除该智能体吗？此操作不可恢复。',
    deleteAgentConfirm: '确定要删除智能体 "{name}" 吗？此操作不可恢复。',
    statusUpdateSuccess: '状态更新成功',
    selectLlmModel: '请选择大语言模型',
    selectTtsModel: '请选择语音合成模型',
    templateLoaded: '已加载模板: {name}',
    updateSuccess: '更新成功',
    createSuccess: '创建成功',
    deployTitle: '快速部署智能体',
    sourceTemplate: '源模板',
    newAgentName: '新智能体名称',
    confirmDeploy: '确定部署',
    unnamedTemplate: '未命名模板',
    pluginCodePlaceholder: '请输入插件编码 (Provider Code)',
    pluginTypeFunction: '函数 (Function)',
    pluginTypePlugin: '插件 (Plugin)',
    fieldsDefinition: '参数定义',
    fieldsDefinitionTip: '请输入插件的参数定义 (JSON 格式)',
    auditConfirm: '确定要通过插件 "{name}" 的审核吗？',
    auditSuccess: '审核成功',
    inputVersion: '请输入新版本号',
    versionFormatError: '版本号格式不正确 (例如: 1.0.1)',
    hotUpdateTitle: '插件热更新',
    hotUpdateSuccess: '热更新成功',
    fieldsJsonError: '参数定义必须是有效的 JSON 格式',
    agentDetail: '智能体详情',
    unnamedAgent: '未命名智能体',
    fetchDetailFailed: '获取智能体详情失败',
    language: '语言',
    langCode: '语言编码',
    sort: '排序',
    creator: '创建人',
    createdAt: '创建时间',
    updater: '更新人',
    updatedAt: '更新时间',
    wechatOpenid: '微信OpenID',
    agentTemplateId: '智能体模板ID',
    templateDetail: '模板详情',
    unnamedTemplate: '未命名模板',
    fetchTemplateDetailFailed: '获取模板详情失败'
  },
  system: {
    // 系统配置
    systemConfigTips: '系统配置',
    basicSettings: '基本设置',
    systemName: '系统名称',
    enterSystemName: '请输入系统名称',
    systemVersion: '系统版本',
    companyName: '公司名称',
    enterCompanyName: '请输入公司名称',
    contactEmail: '联系邮箱',
    enterContactEmail: '请输入联系邮箱',
    enterValidEmail: '请输入有效的邮箱地址',
    defaultLanguage: '默认语言',
    chinese: '简体中文',
    english: 'English',
    timeZone: '时区',
    gmt8ChinaTime: 'GMT+8 (中国标准时间)',
    gmt5UsEastern: 'GMT-5 (美国东部时间)',
    gmt0Greenwich: 'GMT+0 (格林威治标准时间)',
    gmt9Japan: 'GMT+9 (日本标准时间)',
    securitySettings: '安全设置',
    passwordPolicy: '密码策略',
    simple: '简单',
    medium: '中等',
    strong: '强',
    sessionTimeout: '会话超时',
    enterSessionTimeout: '请输入会话超时时间',
    minutes: '分钟',
    maxLoginAttempts: '最大登录尝试次数',
    times: '次',
    emailSettings: '邮件设置',
    smtpServer: 'SMTP 服务器',
    enterSmtpServer: '请输入 SMTP 服务器地址',
    smtpPort: 'SMTP 端口',
    enterSmtpPort: '请输入 SMTP 端口',
    senderEmail: '发件人邮箱',
    enterSenderEmail: '请输入发件人邮箱',
    senderPassword: '发件人密码',
    enterSenderPassword: '请输入发件人密码',
    testEmail: '发送测试邮件',
    storageSettings: '存储设置',
    storagePath: '存储路径',
    enterStoragePath: '请输入存储路径',
    maxFileSize: '最大文件大小',
    enterMaxFileSize: '请输入最大文件大小',
    megabytes: 'MB',
    cleanupDays: '自动清理天数',
    days: '天',
    cleanupStorage: '清理存储',
    emailTestSuccess: '邮件发送测试成功',
    emailTestFailed: '邮件发送测试失败',
    cleanupSuccess: '存储清理成功',
    cleanupFailed: '存储清理失败',
    serverSettings: '服务端设置',
    serverWebsocket: 'WebSocket 地址',
    enterServerWebsocket: '请输入 WebSocket 地址 (多个地址用分号分隔)',
    serverSecret: '服务端密钥',
    enterServerSecret: '请输入服务端密钥',
    serverMqttGateway: 'MQTT 网关',
    enterServerMqttGateway: '请输入 MQTT 网关地址',
    serverOta: 'OTA 地址',
    enterServerOta: '请输入 OTA 更新地址',
    allowUserRegister: '允许用户注册',
    generateSecret: '生成密钥',
    initSecretSuccess: '密钥初始化成功',
    initSecretFailed: '密钥初始化失败',
    serverMonitor: '服务器监控',
    realtimeUpdate: '实时更新',
    getMonitorInfoFailed: '获取服务器监控信息失败',
    cpuUsage: 'CPU 使用率',
    memUsage: '内存使用率',
    jvmUsage: 'JVM 使用率',
    diskUsage: '磁盘使用率',
    cpuMemInfo: 'CPU & 内存信息',
    jvmInfo: 'JVM 信息',
    serverInfo: '服务器信息',
    diskInfo: '磁盘状态',
    cpuNum: 'CPU 核心数',
    cpuUsed: 'CPU 用户使用率',
    cpuSys: 'CPU 系统使用率',
    cpuFree: 'CPU 当前空闲率',
    memTotal: '内存总量',
    memUsed: '内存已用',
    memFree: '内存剩余',
    jvmName: 'JVM 名称',
    jvmVersion: 'Java 版本',
    jvmTotal: 'JVM 总内存',
    jvmFree: 'JVM 剩余内存',
    jvmStartTime: '启动时间',
    jvmRunTime: '运行时长',
    jvmHome: '安装路径',
    computerName: '服务器名称',
    computerIp: '服务器 IP',
    osName: '操作系统',
    osArch: '系统架构',
    userDir: '项目路径',
    diskPath: '盘符路径',
    diskType: '文件系统',
    diskTotal: '总大小',
    diskUsed: '已用大小',
    alarmRules: '告警规则',
    alarmHistory: '告警历史',
    alarmHistoryTips: '告警历史记录，展示系统运行中的各类异常和资源使用预警。',
    basicSettingsDesc: '管理系统的基本信息、语言和时区设置',
    securitySettingsDesc: '配置登录策略、密码强度及会话超时',
    emailSettingsDesc: '配置 SMTP 服务用于系统通知邮件发送',
    storageSettingsDesc: '配置文件存储路径、配额及自动清理周期',
    serverSettingsDesc: '配置服务器 WebSocket、MQTT 网关及安全密钥',
    enterServerWebsocketTip: '用于设备连接的 WebSocket 地址',
    batchResolveAlarms: '批量处理',
    batchDeleteAlarms: '批量删除',
    alarmTitle: '告警标题',
    alarmLevel: '告警级别',
    alarmCategory: '告警分类',
    alarmType: '告警类型',
    alarmContent: '告警内容',
    triggerTime: '触发时间',
    resolveTime: '处理时间',
    targetUser: '关联用户',
    targetModel: '关联模型',
    systemLevel: '系统级',
    statusUnresolved: '未处理',
    statusIgnored: '已忽略',
    statusResolved: '已解决',
    resolve: '处理',
    resolveAlarm: '处理告警',
    batchResolve: '批量处理',
    confirmBatchResolve: '确定要将选中的告警标记为已解决吗？',
    alarmDetail: '告警详情',
    inputTitle: '请输入告警标题',
    selectLevel: '请选择告警级别',
    jobManagementTips: '管理系统后台定时执行的任务，支持动态修改 Cron 表达式、暂停、恢复和立即执行。',
    jobLogTips: '查看定时任务的执行历史记录，包括成功状态、执行时长和异常信息。',
    beanName: 'Bean 名称',
    jobParams: '参数',
    cronExpression: 'Cron 表达式',
    jobLog: '任务日志',
    runOnce: '立即执行',
    pause: '暂停',
    resume: '恢复',
    statusNormal: '正常',
    statusPaused: '暂停',
    inputBeanName: '请输入 Bean 名称',
    inputJobParams: '请输入任务参数',
    inputCronExpression: '请输入 Cron 表达式',
    cronOnline: '在线生成 Cron 表达式',
    confirmRunOnce: '确定要立即执行该任务吗？',
    jobId: '任务 ID',
    inputJobId: '请输入任务 ID',
    consumeTime: '耗时',
    executionTime: '执行时间',
    jobLogDetail: '任务日志详情',
    errorMessage: '错误信息',
    diskFree: '可用大小',
    action: '操作',
    createTime: '创建时间',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    batchExport: '批量导出',
    unreadNotifications: '条未读通知',
    logId: '日志 ID',
    jobId: '任务 ID',
    category: '分类',
    level: '级别',
    type: '类型',
    systemLevel: '系统级',
    resourceLevel: '资源级',
    thresholdTrigger: '阈值触发',
    changeTrigger: '变动触发',
    trendTrigger: '趋势触发',
    BALANCE: '余额',
    QUOTA: '额度',
    triggerConditions: '触发条件',
    SYSTEM: '系统级',
    RESOURCE: '资源级',
    INFO: '信息',
    WARNING: '警告',
    WARN: '警告',
    ERROR: '错误',
    CRITICAL: '严重',
    FATAL: '致命',
    DEBUG: '调试',

    // 告警管理
    alarmManagementTips: '告警管理记录',
    confirmBatchResolve: '确定要将选中的告警标记为已解决吗？',
    batchResolve: '批量处理',
    alarmDetail: '告警详情',
    alarmTitle: '告警标题',
    alarmLevel: '告警级别',
    alarmCategory: '告警分类',
    alarmType: '告警类型',
    alarmContent: '告警内容',
    triggerTime: '触发时间',
    resolveTime: '处理时间',
    statusUnresolved: '未处理',
    statusIgnored: '已忽略',
    statusResolved: '已解决',
    batchResolveAlarms: '批量处理',
    batchDeleteAlarms: '批量删除',
    confirmBatchDeleteAlarms: '确定要批量删除选中的告警记录吗？',
    alarmHistoryTips: '告警历史记录，查看系统中所有的告警触发日志。',

    // 日志管理
    logManagementTips: '日志管理',
    export: '导出',
    exporting: '正在导出日志...',
    exportSuccess: '日志导出成功',
    exportFailed: '日志导出失败',
    selectLogsFirst: '请先选择要导出的日志',
    batchExporting: '正在批量导出...',
    batchExportSuccess: '批量导出成功',
    batchExportFailed: '批量导出失败',
    exportingSingle: '正在导出单个日志...',
    exportSingleSuccess: '导出成功',
    exportSingleFailed: '导出失败',
    confirmDeleteLog: '确定要删除该日志吗？',
    deleteLogSuccess: '删除成功',
    deleteLogFailed: '删除失败',
    totalLogs: '日志总数',
    successLogs: '成功日志',
    failedLogs: '失败日志',
    userOperationLog: '用户操作日志',
    roleOperationLog: '角色操作日志',
    deviceOperationLog: '设备操作日志',
    agentOperationLog: '智能体操作日志',
    roleName: '角色名称',
    permissionChange: '权限变更记录',
    deviceId: '设备ID',
    agentId: '智能体ID',
    operationStatus: '操作状态',
    operationContent: '操作内容',
    operationTime: '操作时间',
    exportPdf: '导出 PDF',
    exportExcel: '导出 Excel',
    logDetail: '日志详情',
    logType: '日志类型',
    targetType: '对象类型',
    targetId: '对象ID',
    userAgent: '浏览器标识',
    getLogsFailed: '获取日志列表失败',
    startTime: '开始时间',
    endTime: '结束时间',
    usernamePlaceholder: '请输入用户名',
    ipPlaceholder: '请输入 IP 地址',
    success: '成功',
    fail: '失败',
    clear: '清空',
    confirmClearLogs: '确定要清空所有日志吗？此操作不可恢复。',
    clearSuccess: '清空成功',
    clearFailed: '清空失败',
    copyError: '复制错误',
    copySuccess: '复制成功',
    errorDetail: '错误详情',
    viewUser: '查看用户',
    viewDevice: '查看设备',
    viewAgent: '查看智能体',
    viewRole: '查看角色',

    // 通知管理
    notificationManagement: '通知管理',
    notificationChannel: '通知渠道',
    notificationManagementTips: '管理系统内所有的通知记录',
    notificationSearchPlaceholder: '搜索标题或内容',
    batchOperations: '批量操作',
    notificationType: '通知类型',
    notificationTitle: '通知标题',
    notificationContent: '通知内容',
    sender: '发送者',
    recipient: '接收者',
    allUsers: '全体用户',
    notificationPriority: '通知优先级',
    unreadNotification: '未读',
    markedAsRead: '已标记为已读',
    confirmDeleteNotification: '确定要删除选中的通知吗？',
    notificationDetail: '通知详情',
    sendNotification: '发送通知',
    selectNotificationType: '选择通知类型',
    selectNotificationStatus: '选择通知状态',
    selectNotificationPriority: '选择通知优先级',
    highPriority: '高优先级',
    mediumPriority: '中优先级',
    lowPriority: '低优先级',
    systemNotification: '系统通知',
    alertNotification: '告警通知',
    messageNotification: '消息通知',
    systemNotificationTips: '管理系统下发的全局通知、告警消息及业务提醒，支持批量处理与状态追踪',
    systemConfigTips: '配置系统基本信息、安全策略、邮件服务及存储规则等全局运行环境',
    serverMonitorTips: '实时展示服务器 CPU、内存、磁盘及 JVM 运行指标，保障系统高性能稳定运行',
    dictManagementTips: '维护系统全局数据字典，通过动态配置实现业务字段的统一管理与快速复用',
    systemParamsTips: '集中管理系统运行时的核心参数与配置项，支持动态生效以满足灵活的业务需求',
    appearanceSettings: '外观设置',
    themeColor: '主题颜色',
    notificationSettings: '通知设置',
    emailNotifications: '邮件通知',
    emailNotificationsTip: '开启后系统将通过邮件发送重要通知',
    smsNotifications: '短信通知',
    smsNotificationsTip: '开启后系统将通过短信发送重要通知',
    privacySettings: '隐私设置',
    publicProfile: '公开个人资料',
    publicProfileTip: '开启后其他用户可以查看您的个人资料',
    jobManagementTips: '管理系统后台定时任务',
    jobLogTips: '查看定时任务执行日志',
    logManagementTips: '查看并管理系统操作日志',
    notificationTemplateTips: '配置通知推送模板',
    notificationChannelTips: '管理通知发送渠道',
    batchExportFailed: '批量导出失败',
    exportingSingle: '正在导出单个日志...',
    exportSingleSuccess: '导出成功',
    exportSingleFailed: '导出失败',
    confirmDeleteLog: '确定要删除该日志吗？',
    deleteLogSuccess: '删除成功',
    deleteLogFailed: '删除失败',
    getLogsFailed: '获取日志列表失败',
    selectLogType: '请选择日志类型',
    loginLog: '登录日志',
    operationLog: '操作日志',
    errorLog: '错误日志',
    systemLog: '系统日志',
    usernamePlaceholder: '请输入用户名',
    ipPlaceholder: '请输入 IP 地址',
    to: '至',
    startTime: '开始时间',
    endTime: '结束时间',
    totalLogs: '总日志数',
    successLogs: '成功日志',
    failedLogs: '失败日志',

    // 日志枚举
    logEnums: {
      type: {
        operation: '操作',
        error: '错误',
        system: '系统',
        login: '登录'
      },
      targetType: {
        user: '用户',
        role: '角色',
        device: '设备',
        agent: '智能体',
        job: '定时任务'
      },
      action: {
        USER_CREATE: '创建用户',
        USER_UPDATE: '更新用户',
        USER_DELETE: '删除用户',
        USER_LEVEL_DOWNGRADE: '等级降级',
        CHANGE_PASSWORD: '修改密码',
        CHANGE_PASSWORD_DIRECTLY: '重置密码',
        ROLE_CREATE: '创建角色',
        ROLE_UPDATE: '更新角色',
        ROLE_DELETE: '删除角色',
        DEVICE_CREATE: '添加设备',
        DEVICE_UPDATE: '更新设备',
        DEVICE_DELETE: '删除设备',
        DEVICE_BIND: '绑定设备',
        DEVICE_UNBIND: '解绑设备',
        DEVICE_BATCH_OPERATION: '批量操作设备',
        AGENT_CREATE: '创建智能体',
        AGENT_UPDATE: '更新智能体',
        AGENT_DELETE: '删除智能体',
        LOGIN: '登录',
        LOGOUT: '登出',
        REGISTER: '注册',
        UPLOAD_AVATAR: '上传头像'
      }
    },

    // 通知管理
    notificationManagementTips: '通知管理',
    getNotificationsFailed: '获取通知列表失败',
    markAsReadSuccess: '已标记为已读',
    markAsReadFailed: '标记失败',
    markAsReadConfirm: '确定要将此通知标记为已读吗？',
    batchMarkAsReadSuccess: '批量标记已读成功',
    batchMarkAsReadFailed: '批量标记失败',
    batchMarkAsReadConfirm: '确定要将选中的通知全部标记为已读吗？',
    batchMarkAsUnreadSuccess: '批量标记未读成功',
    batchMarkAsUnreadFailed: '批量标记失败',
    batchMarkAsUnreadConfirm: '确定要将选中的通知全部标记为未读吗？',
    deleteNotificationSuccess: '通知删除成功',
    deleteNotificationFailed: '通知删除失败',
    deleteNotificationConfirm: '确定要删除此通知吗？',
    batchDeleteNotificationSuccess: '批量删除成功',
    batchDeleteNotificationFailed: '批量删除失败',
    batchDeleteNotificationConfirm: '确定要批量删除选中的通知吗？',
    sendNotificationSuccess: '通知发送成功',
    sendNotificationFailed: '通知发送失败',
    updateNotificationSuccess: '通知更新成功',
    updateNotificationFailed: '通知更新失败',
    selectNotificationsFirst: '请先选择通知',
    noUnreadNotificationsSelected: '选中的通知中没有未读项',
    noReadNotificationsSelected: '选中的通知中没有已读项',
    sendNotification: '发送通知',
    editNotification: '编辑通知',
    enterNotificationTitle: '请输入通知标题',
    enterNotificationContent: '请输入通知内容',
    notificationTitleLength: '标题长度在 5 到 100 个字符之间',
    notificationContentLength: '内容长度在 10 到 1000 个字符之间',
    selectNotificationChannels: '请选择通知渠道',
    enterRecipientUsername: '请输入接收人用户名',
    allUsers: '全部用户',
    specificUser: '特定用户',
    lowPriority: '低优先级',
    mediumPriority: '中优先级',
    highPriority: '高优先级',
    notificationSearchPlaceholder: '搜索通知标题或内容',
    selectNotificationType: '请选择通知类型',
    selectNotificationStatus: '请选择通知状态',
    selectNotificationPriority: '请选择通知优先级',
    notificationTitle: '通知标题',
    notificationContent: '通知内容',
    notificationType: '通知类型',
    receiver: '接收人',
    sendTime: '发送时间',
    status: '状态',
    sent: '已发送',
    pending: '待发送',
    failed: '发送失败',
    unreadNotification: '未读',
    readNotification: '已读',
    deletedNotification: '已删除',
    systemNotification: '系统通知',
    alertNotification: '告警通知',
    updateNotification: '更新通知',
    reminderNotification: '提醒通知',
    infoNotification: '信息通知',
    markAsRead: '标记已读',
    channels: '通知渠道',
    recipient: '接收人',
    
    // 通知渠道
    notificationChannelTips: '通知渠道配置',
    systemChannel: '站内信',
    systemChannelDescription: '系统内部消息通知，用户登录后可见',
    emailChannel: '邮件通知',
    emailChannelDescription: '通过电子邮件发送通知',
    smtpHost: 'SMTP 主机',
    enterSmtpHost: '请输入 SMTP 主机地址',
    smtpUsername: 'SMTP 用户名',
    enterSmtpUsername: '请输入 SMTP 用户名',
    smtpPassword: 'SMTP 密码',
    enterSmtpPassword: '请输入 SMTP 密码',
    smtpEncryption: '加密方式',
    selectSmtpEncryption: '请选择加密方式',
    noEncryption: '无加密',
    senderName: '发件人名称',
    enterSenderName: '请输入发件人名称',
    smsChannel: '短信通知',
    smsChannelDescription: '通过第三方短信服务商发送短信通知',
    apiKey: 'API 密钥',
    enterApiKey: '请输入 API 密钥',
    apiSecret: 'API 密钥密码',
    enterApiSecret: '请输入 API 密钥密码',
    apiEndpoint: 'API 端点',
    enterApiEndpoint: '请输入 API 端点地址',
    senderId: '发送者 ID',
    enterSenderId: '请输入发送者 ID',
    testSms: '测试短信',
    wechatChannel: '微信通知',
    wechatChannelDescription: '通过微信公众号模板消息发送通知',
    appId: 'AppID',
    enterAppId: '请输入 AppID',
    appSecret: 'AppSecret',
    enterAppSecret: '请输入 AppSecret',
    templateId: '模板 ID',
    enterTemplateId: '请输入模板 ID',
    testWechat: '测试微信',
    recipientEmail: '收件人邮箱',
    enterRecipientEmail: '请输入收件人邮箱',
    recipientPhone: '收件人手机号',
    enterRecipientPhone: '请输入收件人手机号',
    recipientOpenId: '收件人 OpenID',
    enterRecipientOpenId: '请输入收件人 OpenID',
    testMessage: '测试消息',
    enterTestMessage: '请输入测试消息内容',
    testNotification: '测试通知',

    // 通知模板
    notificationTemplate: '通知模板',
    createTemplate: '创建模板',
    editTemplate: '编辑模板',
    templateName: '模板名称',
    templateNamePlaceholder: '请输入模板名称',
    selectTemplateType: '请选择模板类型',
    templateContentPlaceholder: '请输入模板内容，支持使用 {变量名} 格式的占位符',
    templateHelpText: '支持使用 {username}、{title}、{content}、{time} 等变量占位符',
    templateNameRequired: '请输入模板名称',
    templateTypeRequired: '请选择模板类型',
    templateContentRequired: '请输入模板内容',
    templateChannelsRequired: '请选择通知渠道',
    enableSelected: '启用选中',
    disableSelected: '禁用选中',
    deleteSelected: '删除选中',
    notificationChannels: '通知渠道',
    updateChannelSuccess: '渠道配置更新成功',
    updateChannelFailed: '渠道配置更新失败',
    saveChannelSuccess: '渠道配置保存成功',
    saveChannelFailed: '渠道配置保存失败',
    enterRecipient: '请输入收件人',
    testNotificationSuccess: '测试通知发送成功',
    testNotificationFailed: '测试通知发送失败',

    // 权限管理
    roleOperationLogTips: '角色操作日志',
    operator: '操作人',
    target: '操作对象',
    result: '操作结果',
    detail: '详情',
    success: '成功',
    fail: '失败',
    
    actions: {
      apiCallFailed: 'API 调用失败',
      permVerifyFailed: '权限验证失败',
      fileUploadFailed: '文件上传失败',
      emailSendFailed: '邮件发送失败',
      userAuthFailed: '用户认证失败',
      paramVerifyFailed: '参数验证失败',
      networkTimeout: '网络超时',
      userLogin: '用户登录',
      userLogout: '用户登出',
      viewUserList: '查看用户列表',
      createUser: '创建用户',
      editUserInfo: '编辑用户信息',
      deleteUser: '删除用户',
      enableUser: '启用用户',
      disableUser: '禁用用户',
      batchDeleteUser: '批量删除用户',
      viewUserDetail: '查看用户详情',
      viewDeviceList: '查看设备列表',
      addDevice: '添加设备',
      editDeviceInfo: '编辑设备信息',
      deleteDevice: '删除设备',
      deviceOnline: '设备上线',
      deviceOffline: '设备下线',
      deviceRestart: '设备重启',
      firmwareUpgrade: '固件升级',
      bindDeviceToUser: '绑定设备到用户',
      unbindDevice: '解绑设备',
      viewAlarmList: '查看告警列表',
      createAlarmRule: '创建告警规则',
      editAlarmRule: '编辑告警规则',
      deleteAlarmRule: '删除告警规则',
      enableAlarmRule: '启用告警规则',
      disableAlarmRule: '禁用告警规则',
      processAlarm: '处理告警',
      ignoreAlarm: '忽略告警',
      viewNotificationList: '查看通知列表',
      sendNotification: '发送通知',
      editNotification: '编辑通知',
      deleteNotification: '删除通知',
      batchMarkRead: '批量标记已读',
      batchDeleteNotification: '批量删除通知',
      systemStartup: '系统启动',
      systemShutdown: '系统停机',
      systemRestart: '系统重启',
      dbBackup: '数据库备份',
      systemUpdate: '系统更新',
      clearCache: '清理缓存',
      systemMaintenance: '系统维护'
    },
    templates: {
      loginSuccess: '用户登录成功',
      loginFromIp: '从 IP {ip} 登录',
      loginVerified: '登录验证通过',
      logoutNormal: '用户正常登出',
      logoutTimeout: '会话超时登出',
      viewUserListDesc: '查看了用户列表第一页',
      searchUserListDesc: '搜索了用户列表',
      createNewAccount: '创建了新账号',
      adminCreateUser: '管理员创建用户',
      updateUserProfile: '更新了用户资料',
      adminModifyUser: '管理员修改用户',
      adminDeleteUser: '管理员删除用户',
      userDeleteAccount: '用户注销账号',
      adminEnableUser: '管理员启用用户',
      userStatusActivated: '用户状态已激活',
      adminDisableUser: '管理员禁用用户',
      userStatusDeactivated: '用户状态已停用',
      adminBatchDeleteUsers: '管理员批量删除用户',
      userBatchDelete: '批量删除用户操作',
      viewUserDetailDesc: '查看了用户详情',
      adminViewUserInfo: '管理员查看用户信息',
      viewDeviceListDesc: '查看了设备列表',
      searchDeviceListDesc: '搜索了设备列表',
      addNewDevice: '添加了新设备',
      adminBindDevice: '管理员绑定设备',
      updateDeviceInfo: '更新了设备信息',
      adminModifyDevice: '管理员修改设备',
      adminDeleteDevice: '管理员删除设备',
      userRemoveDevice: '用户移除设备',
      deviceConnectSuccess: '设备连接成功',
      deviceOnlineNotice: '设备上线通知',
      deviceDisconnect: '设备断开连接',
      deviceOfflineAlarm: '设备离线告警',
      userRestartDevice: '用户重启设备',
      deviceExecuteRestart: '设备执行重启指令',
      firmwareUpgradeTo: '固件升级至版本 {version}',
      userUpgradeFirmware: '用户升级固件',
      adminBindToUser: '管理员绑定设备到用户',
      userBindDevice: '用户绑定设备',
      adminUnbindDevice: '管理员解绑设备',
      userUnbindDevice: '用户解绑设备',
      viewAlarmListDesc: '查看了告警列表',
      filterAlarmRecords: '筛选告警记录',
      createNewAlarmRule: '创建了新告警规则',
      adminAddAlarmMonitor: '管理员添加告警监控'
    }
  },
  cmsAsset: {
    pageTip: '统一管理和组织系统内的多媒体素材与文档资源',
    uploadAsset: '上传资产',
    sidebarTitle: '主题分类',
    searchThemePlaceholder: '搜索主题...',
    allAssets: '全部资产',
    assetNamePlaceholder: '资产名称',
    assetTypePlaceholder: '资产类型',
    assetStatusPlaceholder: '资产状态',
    typeAudio: '音频',
    typeVideo: '视频',
    typeImage: '图片',
    typeBgm: '背景音乐',
    typeText: '文本',
    typePdf: 'PDF文档',
    typeOther: '其他',
    statusNormal: '正常',
    statusProcessing: '处理中',
    statusAbnormal: '异常',
    statusThumbFailTip: '缩略图生成失败，请检查 FFmpeg 环境',
    query: '查询',
    reset: '重置',
    preview: '预览',
    name: '名称',
    type: '类型',
    status: '状态',
    size: '大小',
    uploadTime: '上传时间',
    action: '操作',
    viewDetail: '详情',
    delete: '删除',
    cardEmpty: '此主题下暂无资产',
    batchSelectedCount: '已选择 {count} 个资产',
    confirmBatchDeleteCount: '确定要删除选中的 {count} 个资产吗？此操作不可恢复',
    batchDelete: '批量删除',
    cancelSelection: '取消选择',
    dialogEditTitle: '编辑资产',
    dialogUploadTitle: '上传资产',
    fieldName: '名称',
    fieldTheme: '所属主题',
    fieldThemePlaceholder: '请选择主题',
    fieldDescription: '描述',
    fieldDescriptionPlaceholder: '请输入资产描述信息',
    fieldSelectFile: '选择文件',
    uploadDragText: '将文件拖到此处，或点击上传',
    uploadTip: '支持多种格式，缩略图将自动生成',
    cancel: '取 消',
    confirm: '确 定',
    pleaseSelectFile: '请选择文件',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    allUploadedSuccess: '全部上传成功',
    partialUploadFailed: '部分资产上传失败',
    assetProcessFailed: '资产处理失败',
    confirmDeleteAsset: '确定删除该资产吗？此操作不可恢复',
    warning: '警告',
    deleteSuccess: '删除成功',
    loadListFailed: '加载资产列表失败',
    getThemeFailed: '获取主题失败',
    uploadingStatus: '正在上传 ({current}/{total}): {filename}'
  },
  cmsTheme: {
    pageTip: '创建和管理资产包的主题分类，组织您的资源库',
    createTheme: '创建主题',
    searchPlaceholder: '搜索名称或描述...',
    query: '查询',
    reset: '重置',
    preview: '预览',
    themeName: '主题名称',
    physicalPath: '物理路径',
    assetCount: '资产数量',
    createDate: '创建日期',
    action: '操作',
    viewDetail: '详情',
    edit: '编辑',
    delete: '删除',
    badgeAssetCount: '{count} 资产',
    noDescription: '暂无描述',
    emptyDesc: '暂无主题，开始创建您的第一个主题吧',
    dialogCreateTitle: '创建新主题',
    dialogEditTitle: '编辑主题',
    fieldThemeName: '主题名称',
    fieldThemeNamePlaceholder: '给主题起个响亮的名字',
    fieldThemeIcon: '主题图标',
    fieldThemeIconPlaceholder: '图片URL或上传图片',
    upload: '上传',
    fieldCardColor: '卡片背景',
    fieldSort: '排序',
    fieldPhysicalPath: '物理路径',
    fieldPhysicalPathPlaceholder: '存储文件夹名称，如: nature_2024',
    fieldPhysicalPathHelp: '留空则默认使用主题名称。建议使用英文/数字/下划线。',
    fieldDescription: '主题描述',
    fieldDescriptionPlaceholder: '简单描述一下这个主题的内容...',
    cancel: '取 消',
    confirm: '确 定',
    danger: '危险操作',
    confirmDeleteWithName: '确认要删除主题 "{name}" 吗？',
    deleteWithFiles: '同时删除服务器上的物理文件夹及其包含的所有资产文件',
    confirmDelete: '确定删除',
    imageUploadSuccess: '图片上传成功',
    uploadFailed: '上传失败',
    saveSuccess: '保存成功',
    saveFailed: '保存失败',
    deleteSuccess: '删除成功',
    fetchListFailed: '获取主题列表失败',
    validationThemeNameRequired: '请输入主题名称',
    validationPhysicalPathPattern: '仅支持字母、数字、下划线'
  },
  cmsTag: {
    pageTip: '管理内容资产标签，支持手动拖拽调整排序。',
    addTag: '新增标签',
    searchPlaceholder: '搜索标签名称...',
    tagName: '标签名称',
    createTime: '创建时间',
    action: '操作',
    edit: '编辑',
    delete: '删除',
    tipDragSort: '提示：拖拽表格行可进行手动排序',
    totalCount: '共 {count} 个标签',
    dialogCreateTitle: '新增标签',
    dialogEditTitle: '编辑标签',
    fieldTagName: '标签名称',
    fieldTagNamePlaceholder: '请输入标签名称',
    fieldSort: '排序值',
    cancel: '取 消',
    confirm: '确 定',
    fetchListFailed: '获取标签列表失败',
    sortUpdateSuccess: '排序更新成功',
    sortUpdateFailed: '排序更新失败',
    searchDragDisabled: '搜索状态下禁止拖拽排序',
    deleteConfirm: '确认删除标签 "{name}" 吗？此操作不可撤销。',
    confirmDelete: '确定',
    cancelDelete: '取消',
    deleteSuccess: '标签删除成功',
    deleteFailed: '标签删除失败',
    updateSuccess: '标签更新成功',
    createSuccess: '标签创建成功',
    operationFailed: '操作失败',
    validationNameRequired: '请输入标签名称',
    validationNameLength: '长度在 1 到 20 个字符'
  },
  cmsThemeDetail: {
    titlePrefix: '主题',
    assetStats: '资产统计',
    totalFiles: '总文件数',
    totalSize: '总容量',
    typeDistribution: '类型分布',
    noAssets: '暂无资产',
    basicInfo: '基本信息',
    displayColor: '显示颜色',
    deleteTheme: '删除主题',
    saveChanges: '保存修改',
    renameFolderTip: '修改物理路径将同步重命名磁盘文件夹',
    confirmPermanentDelete: '确认要永久删除主题 "{name}" 吗？',
    validationPhysicalPathRequired: '请输入物理路径',
    validationPhysicalPathPatternLower: '路径只能包含小写字母、数字和下划线',
    fetchDetailFailed: '获取详情失败'
  },
  cmsAssetDetail: {
    titlePrefix: '资产',
    previewAndCover: '预览与封面',
    replaceCover: '更换封面',
    previewOriginal: '预览原文件',
    tagManagement: '标签管理',
    manage: '管理',
    inputTagPlaceholder: '输入标签',
    addTag: '添加标签',
    assetProperties: '资产属性',
    format: '格式',
    uuid: 'UUID',
    techParams: '技术参数',
    assetDescription: '资产描述',
    descriptionPlaceholder: '请输入详细描述...',
    saved: '已保存',
    saveChanges: '保存修改',
    videoOriginalSize: '原始尺寸',
    videoAdaptive: '自适应',
    playbackRate: '倍速:',
    unsupportedPreview: '该类型暂不支持深度预览',
    escTip: '支持 ESC 键快速关闭',
    download: '下 载',
    fetchDetailFailed: '获取资产详情失败',
    thumbTooLarge: '封面图片大小不能超过 2MB!',
    cropDataFailed: '裁剪数据获取失败',
    thumbUpdateSuccess: '封面更新成功',
    serverNoThumb: '服务器未返回缩略图地址',
    thumbUpdateFailed: '更换封面失败',
    meta: {
      duration: '时长',
      resolution: '分辨率',
      bitrate: '比特率',
      codec: '编码格式',
      durationSeconds: '时长(秒)'
    }
  }
,
  product: {
    pageDesc: '产品档案管理：管理所有物理出厂设备的基础元数据',
    addProduct: '新增产品',
    allProducts: '全部产品',
    smartDevice: '智能设备',
    peripheralAccessory: '周边产品',
    searchPlaceholder: '设备编码/名称/SKU',
    productType: '产品大类',
    deviceCategory: '设备种类',
    peripheralType: '周边类型',
    productId: '产品ID',
    deviceCode: '设备编码(UUID)',
    snCode: '唯一标识(SN)',
    productName: '产品名称',
    skuCode: 'SKU编码',
    warrantyMonths: '保修(月)',
    editProductArchive: '编辑产品档案',
    addProductArchive: '新增产品档案',
    snCodePlaceholder: '出厂唯一物理码/SN',
    batchNo: '生产批次',
    batchNoPlaceholder: '输入批次号筛选',
    activationTime: '激活时间',
    factory: '生产工厂',
    productDescription: '产品描述',
    productImage: '产品图片',
    snCodeRequired: '设备唯一物理标识不能为空',
    productNameRequired: '产品名称不能为空',
    skuCodeRequired: 'SKU编码不能为空',
    productTypeRequired: '产品大类不能为空',
    productDetail: '产品详情',
    deleteProduct: '删除产品',
    basicInfo: '基本信息',
    coreInfo: '核心信息',
    productionAndExtraInfo: '生产与扩展信息',
    productLine: '生产产线',
    extraAttributes: '扩展属性(JSON)',
    priceStrategy: '价格策略',
    priceStrategyDeveloping: '价格策略功能开发中...',
    priceStrategyDesc: '未来将支持设置产品建议零售价、成本价及不同渠道的销售价格',
    inventoryStatus: '库存状态',
    salesStatus: '销售状态',
    onSale: '在售',
    stopSale: '停售',
    preSale: '预售',
    lifecycleStatus: '生命周期',
    planning: '规划中',
    developing: '研发中',
    inProduction: '量产中',
    eol: '已停产',
    warehouseId: '当前仓库ID',
    productOwner: '产品负责人',
    operationLog: '操作日志',
    operationLogDeveloping: '操作日志功能开发中...',
    operationLogDesc: '未来将展示该产品的创建、修改、状态变更等历史记录',
    fetchDetailFailed: '获取产品详情失败',
    productDeleted: '产品已删除',
    enterFactory: '请输入生产工厂',
    enterProductLine: '请输入生产产线',
    enterExtraAttributes: '请输入JSON格式的扩展属性',
    selectLifecycleStatus: '请选择生命周期状态',
    enterWarehouseId: '请输入仓库ID',
    enterOwner: '请输入负责人姓名',
    categoryRequired: '种类不能为空',
    checkBasicInfo: '请检查基本信息页签中的必填项',
    invalidJsonFormat: '扩展属性必须是有效的JSON格式',
    confirmDeletePrefix: '确认删除产品 "',
    confirmDeleteSuffix: '" 吗？此操作不可恢复。',
    confirmDeleteButton: '确定删除',
    loading: '加载中...',
    noProductData: '未获取到产品数据'
  },
  peripheral: {
    pageDesc: '管理NFC卡刷卡记录、卡片绑定状态与激活记录',
    addPeripheral: '新增NFC卡',
    searchPlaceholder: 'NFC UUID/SKU编码',
    peripheralTypePlaceholder: '卡片类型',
    bindingStatusPlaceholder: '绑定状态',
    bindingStatus: '绑定状态',
    bound: '已绑定',
    unbound: '未绑定',
    deviceUuid: 'NFC UUID',
    deviceName: '设备名称',
    peripheralType: '卡片类型',
    unknown: '未知',
    bindUser: '绑定用户',
    bindTime: '绑定时间',
    activationTime: '激活时间',
    remark: '备注',
    createTime: '创建时间',
    updateTime: '更新时间',
    operation: '操作',
    view: '查看',
    edit: '编辑',
    bindUnbind: '绑定/解绑',
    delete: '删除',
    batchDelete: '批量删除',
    refresh: '刷新',
    query: '查询',
    reset: '重置',
    selectedItems: '已选择 {count} 项',
    cancelSelection: '取消选择',
    bindUnbindUser: '绑定/解绑用户',
    currentBind: '当前绑定',
    selectUser: '选择用户',
    selectUserPlaceholder: '请选择用户',
    cancel: '取消',
    unbind: '解绑',
    bind: '绑定',
    confirmBatchDelete: '确认删除选中的 {count} 项吗？',
    warning: '警告',
    confirmDelete: '确认删除该NFC卡记录吗？',
    tips: '提示',
    deleteSuccess: '删除成功',
    bindSuccess: '绑定成功',
    unbindSuccess: '解绑成功',
    peripheralDetail: 'NFC卡详情',
    basicInfo: '基础信息',
    deviceCode: '设备编码',
    macAddress: 'MAC地址',
    bindingInfo: '绑定信息',
    productCategory: '设备大类',
    modifyRemark: '修改备注',
    confirmUnbind: '确认解绑用户吗？',
    statusInfo: '状态信息',
    dataStatus: '数据状态',
    normal: '正常',
    abnormal: '异常',
    peripheralOperations: 'NFC卡操作',
    refreshInfo: '刷新信息',
    backToList: '返回列表',
    remarkInfo: '备注信息',
    noRemark: '暂无备注',
    editRemark: '编辑',
    save: '保存',
    nfcCard: 'NFC卡',
    peripheralTypeLabel: '卡片类型',
    deviceNameLabel: '设备名称',
    deviceCodeLabel: '设备编码',
    macAddressLabel: 'MAC地址',
    remarkLabel: '备注',
    bindTimeLabel: '绑定时间',
    createTimeLabel: '创建时间',
    updateTimeLabel: '更新时间',
    creator: '创建人',
    updater: '更新人',
    currentBindStatus: '当前绑定状态',
    userId: '用户ID',
    userName: '用户名',
    uuid: 'UUID'
  },
  activity: {
    title: '活动标题',
    subtitle: '活动副标题',
    coverImage: '封面图片',
    category: '活动分类',
    categoryOnline: '线上活动',
    categoryOffline: '线下活动',
    categoryPromotion: '促销活动',
    categoryCommunity: '社区活动',
    categoryOther: '其他',
    status: '活动状态',
    statusDraft: '草稿',
    statusPublished: '已发布',
    statusArchived: '已归档',
    statusCanceled: '已取消',
    isTop: '置顶展示',
    publishTime: '发布时间',
    activityStartTime: '活动开始时间',
    activityEndTime: '活动结束时间',
    activityLocation: '活动地点',
    content: '活动内容',
    activityLink: '活动链接',
    organizer: '组织者',
    contactInfo: '联系方式',
    maxParticipants: '最大参与人数',
    currentParticipants: '当前参与人数',
    viewCount: '浏览次数',
    likeCount: '点赞数',
    favoriteCount: '收藏数',
    tags: '标签',
    images: '活动图片',
    imageCaption: '图片说明',
    remark: '备注',
    publishActivity: '发布活动',
    editActivity: '编辑活动',
    activityDetail: '活动详情',
    saveDraft: '保存草稿',
    submit: '提交',
    changeStatus: '变更状态',
    targetStatus: '目标状态',
    totalActivities: '全部活动',
    draftCount: '草稿',
    publishedCount: '已发布',
    archivedCount: '已归档',
    canceledCount: '已取消',
    topDisplayCount: '置顶展示',
    searchPlaceholder: '搜索活动标题',
    categoryPlaceholder: '选择分类',
    statusPlaceholder: '选择状态',
    dateRangePlaceholder: '选择活动时间范围',
    uploadCover: '上传封面',
    changeCover: '更换封面',
    addImage: '添加图片',
    insertLink: '插入链接',
    insertImage: '插入图片',
    linkUrl: '链接地址',
    linkText: '链接文字',
    deleteConfirm: '确定要删除该活动吗？',
    statusChangeSuccess: '状态变更成功',
    deleteSuccess: '删除成功',
    saveDraftSuccess: '保存草稿成功',
    createSuccess: '发布成功',
    updateSuccess: '更新成功',
    uploadFail: '上传失败',
    noLimit: '不限',
    tagsPlaceholder: '多个标签用逗号分隔'
  },
  memorial: {
    title: '纪念标题',
    subtitle: '副标题',
    icon: '纪念图标',
    thumbnail: '缩略图',
    backgroundImage: '背景图',
    seriesName: '纪念系列',
    memorialType: '纪念类型',
    activityId: '关联活动',
    checkInLocation: '打卡地点',
    checkInTime: '打卡时间',
    antiFakeCode: '防伪码',
    description: '详细描述',
    acquireCondition: '获取条件说明',
    usageInstruction: '使用说明',
    status: '纪念状态',
    statusDraft: '草稿',
    statusPublished: '已发布',
    statusExpired: '已过期',
    statusDisabled: '已禁用',
    acquireStatus: '获取状态',
    acquireAvailable: '可获取',
    acquireAcquired: '已获取',
    acquireExpired: '已失效',
    visibility: '可见范围',
    visibilityPublic: '公开',
    visibilityPrivate: '私有',
    visibilityActivityOnly: '仅活动参与者',
    acquirePermission: '获取权限',
    permissionAll: '所有人',
    permissionActivityUser: '活动参与者',
    permissionInvited: '受邀用户',
    acquireCount: '获取次数',
    shareCount: '分享次数',
    sortOrder: '排序序号',
    remark: '备注',
    createMemorial: '创建纪念',
    editMemorial: '编辑纪念',
    saveDraft: '保存草稿',
    submit: '提交',
    changeStatus: '变更状态',
    targetStatus: '目标状态',
    totalMemorials: '全部纪念',
    draftCount: '草稿',
    publishedCount: '已发布',
    expiredCount: '已过期',
    disabledCount: '已禁用',
    deleteConfirm: '确定要删除该纪念吗？',
    deleteSuccess: '删除成功',
    statusChangeSuccess: '状态变更成功',
    saveDraftSuccess: '保存草稿成功',
    createSuccess: '创建成功',
    updateSuccess: '更新成功',
    uploadFail: '上传失败',
    seriesAnniversary: '周年纪念',
    seriesFestival: '节日纪念',
    seriesEvent: '活动纪念',
    seriesAchievement: '成就纪念',
    seriesLimited: '限定纪念',
    typeBadge: '勋章',
    typeSticker: '贴纸',
    typeStamp: '集章',
    typeMedal: '徽章',
    typeCertificate: '证书'
  },
  rightsShop: {
    title: '权益商店',
    exchangeRecords: '兑换记录',
    createRights: '创建权益',
    editRights: '编辑权益',
    rightsName: '权益名称',
    rightsIcon: '权益图标',
    rightsType: '权益类型',
    rightsTypeTicket: '票务类',
    rightsTypeExperience: '体验类',
    rightsTypeHidden: '隐藏款',
    exchangePoints: '兑换积分',
    levelLimit: '等级限制',
    stockQuantity: '库存数量',
    dailyExchangeLimit: '每日兑换上限',
    perUserLimit: '每人兑换限制',
    validityPeriod: '有效期',
    supportRefund: '是否支持退换',
    status: '状态',
    statusDraft: '草稿',
    statusPending: '待审核',
    statusOnline: '已上线',
    statusOffline: '已下线',
    totalRights: '全部权益',
    totalExchanged: '已兑换',
    exchangeStatusUnused: '待使用',
    exchangeStatusUsed: '已使用',
    exchangeStatusExpired: '已过期',
    exchangeStatusCancelled: '已取消',
    pointsExchange: '积分兑换',
    exchangeSuccess: '兑换成功',
    exchangeFail: '兑换失败',
    cancelExchange: '取消兑换',
    useExchange: '核销',
    cancelSuccess: '取消成功，积分已退还',
    useSuccess: '核销成功'
  }
};
